import ApplyV2QuestionsList from '@core/components/ApplyDialogV2/ApplyV2QuestionsStep/ApplyV2QuestionsList'
import ApplyV2Button from '@core/components/ApplyDialogV2/ApplyV2Button'
import parseDateStringToObject from '@core/utils/helpers/parseDateStringToObject'
import ApplySkeleton from '@core/components/ApplyDialogV2/ApplySkeleton'
import useApplyV2NavTranslations from '@core/utils/hooks/useApplyV2NavTranslations'
// import { buildCustomFieldDateValidation } from './buildCustomFieldDateValidation' // DEPRECATED: Custom field date validation
import dayjs from 'dayjs'
import { FormikProvider, type FormikTouched, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import {
    ApplyV2CustomFieldTypeConst,
    type ApplyV2FileAttachment,
    type ApplyV2Question,
    type ApplyV2SettingsSectionName,
    type ApplyV2TempCourseFile,
    type AttributesCheckboxesForm,
    type GetApplyV2SettingsResponse,
    type SingleSelectKey,
    type MultiSelectKey,
    type TextKey,
    type LongTextKey,
    type YesNoKey,
    type StarRatingKey,
    type DateDayKey,
    type DateMonthKey,
    type DateYearKey,
    type DateRangeStartDayKey,
    type DateRangeStartMonthKey,
    type DateRangeStartYearKey,
    type DateRangeEndDayKey,
    type DateRangeEndMonthKey,
    type DateRangeEndYearKey,
    type NumberKey,
    type AttachmentKey,
    type QualifyingKey,
    type CustomFieldKey,
    type CustomFieldDateDayKey,
    type CustomFieldDateMonthKey,
    type CustomFieldDateYearKey,
    type AttributeBoolKey,
    type AttributeCheckboxesKey,
    type AttributeDateDayKey,
    type AttributeDateMonthKey,
    type AttributeDateYearKey,
    type AttributeShortTextKey,
    type AttributeTextKey,
    type AttributeRatingKey,
    type AttributeDropdownKey,
    type ApplyV2QuestionsFormValues,
} from '@core/app/types/applyV2Type'
import {
    useGetAllQuestionsV2ApplyQuery,
    usePutQuestionV2ApplyMutation,
    useValidateQuestionsV2ApplyMutation,
} from '@core/app/api/applyJobV2Api'
import { useApplyV2Context } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'
import * as Yup from 'yup'
import './ApplyV2QuestionsStep.scss'

const baseClass = 'ApplyV2QuestionsStep'

function ApplyV2QuestionsStep() {
    const { storageData } = useApplyV2Context()
    const [isErrorUpdateAnswer, setIsErrorUpdateAnswer] = useState<boolean>(false)
    const { data, isLoading, isFetching, refetch } = useGetAllQuestionsV2ApplyQuery(
        { uid: storageData?.postInitUid || '' },
        { skip: !storageData?.postInitUid }
    )

    useEffect(() => {
        if (refetch) refetch()
    }, [])

    // useEffect(() => {
    //     const timer = setTimeout(() => {
    //         console.log('REFETCHING')
    //         if (refetch) refetch()
    //     }, 5000)
    //
    //     return () => {
    //         clearTimeout(timer)
    //     }
    // }, [])

    const refetchAllQuestions = () => {
        if (refetch) refetch()
    }

    if (isLoading || !storageData?.postInitUid) {
        return (
            <div className={`${baseClass}__container`}>
                <ApplySkeleton style={{ width: '100%', height: '100px' }} isLoading={true} />
                <ApplySkeleton style={{ width: '100%', height: '50px' }} isLoading={true} />
                <ApplySkeleton style={{ width: '100%', height: '50px' }} isLoading={true} />
                <div style={{ width: '100%', display: 'flex', justifyContent: 'end' }}>
                    <ApplySkeleton style={{ width: '80px', height: '40px' }} isLoading={true} />
                </div>
            </div>
        )
    }

    const questions = [...(data?.data?.questions || [])].sort((a, b) => a.orderId - b.orderId)

    // console.log(questions)

    return (
        <div className={baseClass}>
            <ApplyV2QuestionsForm
                questions={questions}
                setIsErrorUpdateAnswer={(val) => {
                    // console.log('ApplyV2QuestionsForm   setIsErrorUpdateAnswer, : ', val)
                    setIsErrorUpdateAnswer(val)
                }}
                refetchAllQuestions={refetchAllQuestions}
            />
        </div>
    )
}

interface ApplyV2QuestionsFormProps {
    // children: React.ReactNode
    questions: ApplyV2Question[]
    setIsErrorUpdateAnswer: (value: boolean) => void
    refetchAllQuestions: () => void
}

function ApplyV2QuestionsForm({ questions, setIsErrorUpdateAnswer, refetchAllQuestions }: ApplyV2QuestionsFormProps) {
    const { getTitle } = useApplyV2NavTranslations()
    const { storageData, onNextStep, settingsData } = useApplyV2Context()
    const [loadingItems, setLoadingItems] = useState<Set<string>>(new Set())
    const [validateRequest, { isLoading: isValidateLoading }] = useValidateQuestionsV2ApplyMutation()

    const addLoadingItem = (id: string) => {
        setLoadingItems((prev) => new Set(prev).add(id))
    }

    const removeLoadingItem = (id: string) => {
        setLoadingItems((prev) => {
            const next = new Set(prev)
            next.delete(id)
            return next
        })
    }

    // console.log('SEEeeE', loadingItems)

    const buildInitialValues = (questions: ApplyV2Question[], parent?: ApplyV2Question | null): Record<string, any> => {
        return questions.reduce(
            (acc, question) => {
                const questionKey = `${question.type}_${question.questionId}`

                // const parentKey = parent ? `${parent.type}_${parent.questionId}` : null
                // console.log(
                //     'INITIAL VALUES',
                //     parent?.questionId,
                //     parent?.type,
                //     parent?.type === 'customField' && parent?.customField?.typeId
                // )

                if (question.type === 'customField' && 'customField' in question) {
                    switch (question.customField?.typeId) {
                        case ApplyV2CustomFieldTypeConst.MultiSelect:
                            acc[questionKey] = question.answer?.value || []
                            break
                        case ApplyV2CustomFieldTypeConst.SingleSelect:
                            acc[questionKey] = question.answer?.value ?? null
                            break
                        case ApplyV2CustomFieldTypeConst.Date:
                            const dateValue = typeof question.answer?.value === 'string' ? question.answer.value : null
                            const { day, month, year } = parseDateStringToObject(dateValue)
                            acc[`day_date_${questionKey}`] = day
                            acc[`month_date_${questionKey}`] = month
                            acc[`year_date_${questionKey}`] = year
                            break
                        case ApplyV2CustomFieldTypeConst.Integer:
                            // const decimals = question.customField?.properties?.decimals ?? 0
                            const decimals = question.customField?.properties?.decimals
                            // const val = Number(question.answer?.value ?? 0).toFixed(decimals)
                            const val = question.answer?.value
                                ? Number(question.answer?.value ?? 0).toFixed(decimals)
                                : null
                            acc[questionKey] = val
                            break
                        case ApplyV2CustomFieldTypeConst.Text:
                            acc[questionKey] = question.answer?.value ?? null
                            break
                        default:
                            acc[questionKey] = question.answer?.value ?? ''
                    }
                } else if (question.type === 'attribute') {
                    if (question.attribute.bool) {
                        acc[`bool_${questionKey}`] = question.answer?.value?.bool ?? null
                    }
                    if (question.attribute.checkbox) {
                        const iShowCheckboxes = question.attribute.checkbox
                        const checkedAnswer = Array.isArray(question.answer?.value?.checkbox)
                            ? question?.answer?.value.checkbox
                            : []
                        acc[`checkboxes_${questionKey}`] = (question.attribute.checkboxes ?? []).map((item) => {
                            const answerItem = (Array.isArray(checkedAnswer) ? checkedAnswer : []).find(
                                (t) => t.id === item.id
                            )
                            return {
                                ...item,
                                checked: !!answerItem,
                                rating: answerItem?.rating ?? 0,
                            }
                        })
                        // acc[`checkboxes_${questionKey}`] =
                        //     question.answer?.value?.checkbox ??
                        //     question.attribute.checkboxes?.map((it) => ({
                        //         ...it,
                        //         checked: false,
                        //         rating: 0,
                        //     })) // validation {id: number, rating: number (1-5)} {id: number, name: string, checked: boolean, rating: 0-5}[]
                    }
                    if (question.attribute.date) {
                        const { day, month, year } = parseDateStringToObject(question.answer?.value?.date)
                        acc[`day_date_${questionKey}`] = day
                        acc[`month_date_${questionKey}`] = month
                        acc[`year_date_${questionKey}`] = year
                    }
                    if (question.attribute.shortText) {
                        acc[`shortText_${questionKey}`] = question.answer?.value?.shortText ?? '' // validation string length 0 - 1024
                    }
                    if (question.attribute.text) {
                        acc[`text_${questionKey}`] = question.answer?.value?.text ?? '' // validation string length 0 - 5000
                    }
                    if (question.attribute.rating) {
                        acc[`rating_${questionKey}`] = question.answer?.value?.rating ?? null // validation number 1-5
                    }
                    if (question.attribute.dropdown) {
                        // acc[`dropdown_${questionKey}`] = question.answer?.value?.dropdown ?? null // validation number
                        acc[`dropdowns_${questionKey}`] = question.answer?.value?.dropdown ?? null // validation number
                    }
                } else {
                    switch (question.type) {
                        case 'multiSelect':
                            acc[questionKey] = question.answer?.value || [] // validation number[]
                            break
                        case 'singleSelect':
                            acc[questionKey] = question.answer?.value || null // validation number
                            break
                        case 'date':
                            // const [year = null, month = null, day = null] = question.answer?.value?.split('-') ?? []
                            const { day, month, year } = parseDateStringToObject(question.answer?.value)
                            acc[`day_${questionKey}`] = day
                            acc[`month_${questionKey}`] = month
                            acc[`year_${questionKey}`] = year
                            break
                        // case 'dateRange':
                        //     acc[questionKey] = question.answer?.value || [null, null] // validation [string, string] like ['2022-07-03', '2023-04-02'] - always date string
                        //     break
                        case 'dateRange':
                            const [startDate = null, endDate = null] = question.answer?.value || [null, null]
                            const {
                                year: startYear,
                                month: startMonth,
                                day: startDay,
                            } = parseDateStringToObject(startDate)
                            acc[`startDay_${questionKey}`] = startDay
                            acc[`startMonth_${questionKey}`] = startMonth
                            acc[`startYear_${questionKey}`] = startYear

                            const { year: endYear, month: endMonth, day: endDay } = parseDateStringToObject(endDate)
                            acc[`endDay_${questionKey}`] = endDay
                            acc[`endMonth_${questionKey}`] = endMonth
                            acc[`endYear_${questionKey}`] = endYear

                            // acc[questionKey] = [startDate, endDate]
                            break
                        case 'number':
                            acc[questionKey] = question.answer?.value ?? null //validation number
                            break
                        case 'starRating':
                            acc[questionKey] = question.answer?.value ?? null //validation number 1 - 5
                            break

                        case 'attachment':
                            // console.log(
                            //     question.answer?.value,
                            //     Array.isArray(question.answer?.value),
                            //     typeof question.answer?.value
                            // )
                            acc[questionKey] = Array.isArray(question.answer?.value) ? question.answer?.value : [] // validation {name: string | max length 128, ext: string, base64: string}
                            break
                        case 'yesNo':
                            acc[questionKey] = question.answer?.value ?? null //validation boolean
                            break
                        case 'qualifying':
                            acc[questionKey] = question.answer?.value ?? null //validation boolean
                            break
                        case 'text':
                            acc[questionKey] = question.answer?.value || '' // validation string length 0 - 1024
                            break
                        case 'longText':
                            acc[questionKey] = question.answer?.value || '' // validation string length 0 - 5000
                            break
                        default:
                            // @ts-ignore
                            acc[questionKey] = question.answer?.value ?? ''
                    }
                }

                if (question.children?.length) {
                    Object.assign(acc, buildInitialValues(question.children, question))
                }

                return acc
            },
            {} as Record<string, any>
        )
    }

    const buildValidationSchema = (questions: ApplyV2Question[], parent?: ApplyV2Question): Yup.ObjectSchema<any> => {
        const shape = questions.reduce(
            (acc, question) => {
                const questionKey = `${question.type}_${question.questionId}`
                const testBaseSchemaKey = `${parent?.questionId}__${parent?.type}__${questionKey}`

                if (question.type === 'customField' && 'customField' in question) {
                    switch (question.customField?.typeId) {
                        case ApplyV2CustomFieldTypeConst.MultiSelect:
                            const validateBaseCustomMultiSelectSchema = () => {
                                return Yup.array()
                                    .of(Yup.number())
                                    .nullable()
                                    .test(testBaseSchemaKey, getTitle('3924', 'Required field'), function (value) {
                                        if (!parent) {
                                            if (question.required) {
                                                return (
                                                    value !== null &&
                                                    value !== undefined &&
                                                    Array.isArray(value) &&
                                                    value.length > 0
                                                )
                                            } else {
                                                return true
                                            }
                                        }

                                        const formValues = this.parent
                                        switch (parent.type) {
                                            case 'customField':
                                                switch (parent.customField.typeId) {
                                                    case ApplyV2CustomFieldTypeConst.SingleSelect:
                                                        const [singleParentKey, singleParentValue] =
                                                            Object.entries(formValues).find(([key, value]) => {
                                                                if (key.includes(parent.questionId.toString())) {
                                                                    return true
                                                                }
                                                            }) ?? []

                                                        const isSingleShowCurrentValue =
                                                            singleParentValue === question.parentOptionId
                                                        if (isSingleShowCurrentValue && question.required) {
                                                            return (
                                                                value !== null &&
                                                                value !== undefined &&
                                                                Array.isArray(value) &&
                                                                value.length > 0
                                                            )
                                                        }
                                                        return true

                                                    case ApplyV2CustomFieldTypeConst.MultiSelect:
                                                        const [multiParentKey, multiParentValue] =
                                                            Object.entries(formValues).find(([key, value]) => {
                                                                if (key.includes(parent.questionId.toString())) {
                                                                    return true
                                                                }
                                                            }) ?? []

                                                        const isMultiShowCurrentValue =
                                                            Array.isArray(multiParentValue) &&
                                                            multiParentValue.includes(question.parentOptionId)

                                                        if (isMultiShowCurrentValue && question.required) {
                                                            return (
                                                                value !== null &&
                                                                value !== undefined &&
                                                                Array.isArray(value) &&
                                                                value.length > 0
                                                            )
                                                        }
                                                        return true
                                                    default:
                                                        return true
                                                }
                                            case 'multiSelect':
                                                const [multiParentKey, multiParentValue] =
                                                    Object.entries(formValues).find(([key, value]) => {
                                                        if (key.includes(parent.questionId.toString())) {
                                                            return true
                                                        }
                                                    }) ?? []

                                                const isMultiShowCurrentValue =
                                                    Array.isArray(multiParentValue) &&
                                                    multiParentValue.includes(question.parentOptionId)

                                                if (isMultiShowCurrentValue && question.required) {
                                                    return (
                                                        value !== null &&
                                                        value !== undefined &&
                                                        Array.isArray(value) &&
                                                        value.length > 0
                                                    )
                                                }
                                                return true
                                            case 'singleSelect':
                                            case 'yesNo':
                                            case 'qualifying':
                                                const [caseParentKey, caseParentValue] =
                                                    Object.entries(formValues).find(([key, value]) => {
                                                        if (key.includes(parent.questionId.toString())) {
                                                            return true
                                                        }
                                                    }) ?? []

                                                const isSingleShowCurrentValue =
                                                    caseParentValue === question.parentOptionId
                                                if (isSingleShowCurrentValue && question.required) {
                                                    return (
                                                        value !== null &&
                                                        value !== undefined &&
                                                        Array.isArray(value) &&
                                                        value.length > 0
                                                    )
                                                }
                                                return true

                                            default:
                                                return true
                                        }
                                    })
                            }
                            acc[questionKey] = validateBaseCustomMultiSelectSchema()
                            break
                        case ApplyV2CustomFieldTypeConst.SingleSelect:
                            const validateBaseCustomSingleSelectSchema = () => {
                                return Yup.number()
                                    .nullable()
                                    .test(testBaseSchemaKey, getTitle('3924', 'Required field'), function (value) {
                                        if (!parent) {
                                            if (question.required) {
                                                return value !== null && value !== undefined
                                            } else {
                                                return true
                                            }
                                        }

                                        const formValues = this.parent
                                        switch (parent.type) {
                                            case 'customField':
                                                switch (parent.customField.typeId) {
                                                    case ApplyV2CustomFieldTypeConst.SingleSelect:
                                                        const [singleParentKey, singleParentValue] =
                                                            Object.entries(formValues).find(([key, value]) => {
                                                                if (key.includes(parent.questionId.toString())) {
                                                                    return true
                                                                }
                                                            }) ?? []

                                                        const isSingleShowCurrentValue =
                                                            singleParentValue === question.parentOptionId
                                                        if (isSingleShowCurrentValue && question.required) {
                                                            return value !== null && value !== undefined
                                                        }
                                                        return true

                                                    case ApplyV2CustomFieldTypeConst.MultiSelect:
                                                        const [multiParentKey, multiParentValue] =
                                                            Object.entries(formValues).find(([key, value]) => {
                                                                if (key.includes(parent.questionId.toString())) {
                                                                    return true
                                                                }
                                                            }) ?? []

                                                        const isMultiShowCurrentValue =
                                                            Array.isArray(multiParentValue) &&
                                                            multiParentValue.includes(question.parentOptionId)

                                                        if (isMultiShowCurrentValue && question.required) {
                                                            return value !== null && value !== undefined
                                                        }
                                                        return true
                                                    default:
                                                        return true
                                                }
                                            case 'multiSelect':
                                                const [multiParentKey, multiParentValue] =
                                                    Object.entries(formValues).find(([key, value]) => {
                                                        if (key.includes(parent.questionId.toString())) {
                                                            return true
                                                        }
                                                    }) ?? []

                                                const isMultiShowCurrentValue =
                                                    Array.isArray(multiParentValue) &&
                                                    multiParentValue.includes(question.parentOptionId)

                                                if (isMultiShowCurrentValue && question.required) {
                                                    return value !== null && value !== undefined
                                                }
                                                return true
                                            case 'singleSelect':
                                            case 'yesNo':
                                            case 'qualifying':
                                                const [caseParentKey, caseParentValue] =
                                                    Object.entries(formValues).find(([key, value]) => {
                                                        if (key.includes(parent.questionId.toString())) {
                                                            return true
                                                        }
                                                    }) ?? []

                                                const isSingleShowCurrentValue =
                                                    caseParentValue === question.parentOptionId
                                                if (isSingleShowCurrentValue && question.required) {
                                                    return value !== null && value !== undefined
                                                }
                                                return true

                                            default:
                                                return true
                                        }
                                    })
                            }
                            acc[questionKey] = validateBaseCustomSingleSelectSchema()
                            break
                        case ApplyV2CustomFieldTypeConst.Date:
                            const yearDateCustomField = `year_date_${questionKey}`
                            const monthDateCustomField = `month_date_${questionKey}`
                            const dayDateCustomField = `day_date_${questionKey}`

                            // No validation for custom field date - validation only on backend
                            acc[yearDateCustomField] = Yup.string().nullable()
                            acc[monthDateCustomField] = Yup.string().nullable()
                            acc[dayDateCustomField] = Yup.string().nullable()
                            break
                        case ApplyV2CustomFieldTypeConst.Integer:
                            const { decimals = 0, min, max } = question.customField?.properties || {}

                            // let fieldValidation = Yup.string()
                            //     .nullable()
                            //     .test('is-numeric', 'Must be a valid number', (value) => {
                            //         if (value === null || value === undefined || value === '') return true
                            //         return !isNaN(Number(value.replace(',', '.')))
                            //     })
                            //
                            // if (typeof min === 'number') {
                            //     fieldValidation = fieldValidation.test(
                            //         'min-value',
                            //         `${getTitle('9763', 'Minimum')} ${min}`,
                            //         (value) => {
                            //             if (value === null || value === undefined || value === '') return true
                            //             const numericValue = Number(value.replace(',', '.'))
                            //             return !isNaN(numericValue) && numericValue >= min
                            //         }
                            //     )
                            // }
                            // if (typeof max === 'number') {
                            //     fieldValidation = fieldValidation.test(
                            //         'max-value',
                            //         `${getTitle('9764', 'Maximum')} ${max}`,
                            //         (value) => {
                            //             if (value === null || value === undefined || value === '') return true
                            //             const numericValue = Number(value.replace(',', '.'))
                            //             return !isNaN(numericValue) && numericValue <= max
                            //         }
                            //     )
                            // }
                            //
                            // if (question.required && !parent) {
                            //     fieldValidation = fieldValidation.required(getTitle('3924', 'Required filed'))
                            // }
                            //
                            // acc[questionKey] = fieldValidation
                            const validateBaseCustomIntegerSchema = () => {
                                return Yup.string()
                                    .nullable()
                                    .test(testBaseSchemaKey, getTitle('3924', 'Required field'), function (value) {
                                        // console.log('validateBaseCustomIntegerSchema', value, questionKey)
                                        if (!parent) {
                                            if (question.required) {
                                                if (!value) return false
                                                const numericValue = Number(value.replace(',', '.'))

                                                if (isNaN(numericValue)) {
                                                    return false
                                                }
                                                if (typeof min === 'number' && numericValue < min) {
                                                    return this.createError({
                                                        path: this.path,
                                                        message: `${getTitle('9763', 'Minimum')} ${min}`,
                                                    })
                                                }
                                                if (typeof max === 'number' && numericValue > max) {
                                                    return this.createError({
                                                        path: this.path,
                                                        message: `${getTitle('9764', 'Maximum')} ${max}`,
                                                    })
                                                }
                                                return true
                                            } else {
                                                if (value) {
                                                    const numericValue = Number(value.replace(',', '.'))
                                                    if (isNaN(numericValue)) {
                                                        return this.createError({
                                                            path: this.path,
                                                            message: getTitle('3924', 'Required field'),
                                                        })
                                                    }
                                                    if (typeof min === 'number' && numericValue < min) {
                                                        return this.createError({
                                                            path: this.path,
                                                            message: `${getTitle('9763', 'Minimum')} ${min}`,
                                                        })
                                                    }
                                                    if (typeof max === 'number' && numericValue > max) {
                                                        return this.createError({
                                                            path: this.path,
                                                            message: `${getTitle('9764', 'Maximum')} ${max}`,
                                                        })
                                                    }
                                                    return true
                                                }
                                                return true // TODO FALSE - return test Error message getTitle('3924', 'Required field')
                                            }
                                            return true
                                        } else {
                                            const formValues = this.parent
                                            switch (parent.type) {
                                                case 'customField':
                                                    switch (parent.customField.typeId) {
                                                        case ApplyV2CustomFieldTypeConst.SingleSelect:
                                                            const [singleParentKey, singleParentValue] =
                                                                Object.entries(formValues).find(([key, value]) => {
                                                                    if (key.includes(parent.questionId.toString())) {
                                                                        return true
                                                                    }
                                                                }) ?? []

                                                            const isSingleShowCurrentValue =
                                                                singleParentValue === question.parentOptionId
                                                            if (isSingleShowCurrentValue) {
                                                                if (question.required) {
                                                                    if (!value) return false
                                                                    const numericValue = Number(value.replace(',', '.'))

                                                                    if (isNaN(numericValue)) {
                                                                        return false
                                                                    }
                                                                    if (typeof min === 'number' && numericValue < min) {
                                                                        return this.createError({
                                                                            path: this.path,
                                                                            message: `${getTitle('9763', 'Minimum')} ${min}`,
                                                                        })
                                                                    }
                                                                    if (typeof max === 'number' && numericValue > max) {
                                                                        return this.createError({
                                                                            path: this.path,
                                                                            message: `${getTitle('9764', 'Maximum')} ${max}`,
                                                                        })
                                                                    }
                                                                    return true
                                                                } else {
                                                                    if (value) {
                                                                        const numericValue = Number(
                                                                            value.replace(',', '.')
                                                                        )
                                                                        // console.log(
                                                                        //     'GGGG',
                                                                        //     value,
                                                                        //     numericValue,
                                                                        //     !isNaN(numericValue),
                                                                        //     questionKey
                                                                        // )
                                                                        if (
                                                                            typeof min === 'number' &&
                                                                            numericValue < min
                                                                        ) {
                                                                            return this.createError({
                                                                                path: this.path,
                                                                                message: `${getTitle('9763', 'Minimum')} ${min}`,
                                                                            })
                                                                        }
                                                                        if (
                                                                            typeof max === 'number' &&
                                                                            numericValue > max
                                                                        ) {
                                                                            return this.createError({
                                                                                path: this.path,
                                                                                message: `${getTitle('9764', 'Maximum')} ${max}`,
                                                                            })
                                                                        }
                                                                        return Boolean(value && !isNaN(numericValue))
                                                                    }
                                                                    return true // TODO FALSE - return test Error message getTitle('3924', 'Required field')
                                                                }
                                                                return true
                                                            }
                                                            return true

                                                        case ApplyV2CustomFieldTypeConst.MultiSelect:
                                                            const [multiParentKey, multiParentValue] =
                                                                Object.entries(formValues).find(([key, value]) => {
                                                                    if (key.includes(parent.questionId.toString())) {
                                                                        return true
                                                                    }
                                                                }) ?? []

                                                            const isMultiShowCurrentValue =
                                                                Array.isArray(multiParentValue) &&
                                                                multiParentValue.includes(question.parentOptionId)

                                                            if (isMultiShowCurrentValue) {
                                                                if (question.required) {
                                                                    if (!value) return false
                                                                    const numericValue = Number(value.replace(',', '.'))

                                                                    if (isNaN(numericValue)) {
                                                                        return false
                                                                    }
                                                                    if (typeof min === 'number' && numericValue < min) {
                                                                        return this.createError({
                                                                            path: this.path,
                                                                            message: `${getTitle('9763', 'Minimum')} ${min}`,
                                                                        })
                                                                    }
                                                                    if (typeof max === 'number' && numericValue > max) {
                                                                        return this.createError({
                                                                            path: this.path,
                                                                            message: `${getTitle('9764', 'Maximum')} ${max}`,
                                                                        })
                                                                    }
                                                                    return true
                                                                } else {
                                                                    if (value) {
                                                                        const numericValue = Number(
                                                                            value.replace(',', '.')
                                                                        )
                                                                        if (
                                                                            typeof min === 'number' &&
                                                                            numericValue < min
                                                                        ) {
                                                                            return this.createError({
                                                                                path: this.path,
                                                                                message: `${getTitle('9763', 'Minimum')} ${min}`,
                                                                            })
                                                                        }
                                                                        if (
                                                                            typeof max === 'number' &&
                                                                            numericValue > max
                                                                        ) {
                                                                            return this.createError({
                                                                                path: this.path,
                                                                                message: `${getTitle('9764', 'Maximum')} ${max}`,
                                                                            })
                                                                        }
                                                                        return !!value && !isNaN(numericValue)
                                                                    }
                                                                    return true // TODO FALSE - return test Error message getTitle('3924', 'Required field')
                                                                }
                                                            }
                                                            return true
                                                        default:
                                                            return true
                                                    }
                                                case 'multiSelect':
                                                    const [multiParentKey, multiParentValue] =
                                                        Object.entries(formValues).find(([key, value]) => {
                                                            if (key.includes(parent.questionId.toString())) {
                                                                return true
                                                            }
                                                        }) ?? []

                                                    const isMultiShowCurrentValue =
                                                        Array.isArray(multiParentValue) &&
                                                        multiParentValue.includes(question.parentOptionId)

                                                    if (isMultiShowCurrentValue) {
                                                        if (question.required) {
                                                            if (!value) return false
                                                            const numericValue = Number(value.replace(',', '.'))

                                                            if (isNaN(numericValue)) {
                                                                return false
                                                            }
                                                            if (typeof min === 'number' && numericValue < min) {
                                                                return this.createError({
                                                                    path: this.path,
                                                                    message: `${getTitle('9763', 'Minimum')} ${min}`,
                                                                })
                                                            }
                                                            if (typeof max === 'number' && numericValue > max) {
                                                                return this.createError({
                                                                    path: this.path,
                                                                    message: `${getTitle('9764', 'Maximum')} ${max}`,
                                                                })
                                                            }
                                                            return true
                                                        } else {
                                                            if (value) {
                                                                const numericValue = Number(value.replace(',', '.'))
                                                                if (typeof min === 'number' && numericValue < min) {
                                                                    return this.createError({
                                                                        path: this.path,
                                                                        message: `${getTitle('9763', 'Minimum')} ${min}`,
                                                                    })
                                                                }
                                                                if (typeof max === 'number' && numericValue > max) {
                                                                    return this.createError({
                                                                        path: this.path,
                                                                        message: `${getTitle('9764', 'Maximum')} ${max}`,
                                                                    })
                                                                }
                                                                return !!value && !isNaN(numericValue)
                                                            }
                                                            return true // TODO FALSE - return test Error message getTitle('3924', 'Required field')
                                                        }
                                                    }
                                                    return true
                                                case 'singleSelect':
                                                case 'yesNo':
                                                case 'qualifying':
                                                    const [caseParentKey, caseParentValue] =
                                                        Object.entries(formValues).find(([key, value]) => {
                                                            if (key.includes(parent.questionId.toString())) {
                                                                return true
                                                            }
                                                        }) ?? []

                                                    const isSingleShowCurrentValue =
                                                        caseParentValue === question.parentOptionId
                                                    if (isSingleShowCurrentValue) {
                                                        if (question.required) {
                                                            if (!value) return false
                                                            const numericValue = Number(value.replace(',', '.'))

                                                            if (isNaN(numericValue)) {
                                                                return false
                                                            }
                                                            if (typeof min === 'number' && numericValue < min) {
                                                                return this.createError({
                                                                    path: this.path,
                                                                    message: `${getTitle('9763', 'Minimum')} ${min}`,
                                                                })
                                                            }
                                                            if (typeof max === 'number' && numericValue > max) {
                                                                return this.createError({
                                                                    path: this.path,
                                                                    message: `${getTitle('9764', 'Maximum')} ${max}`,
                                                                })
                                                            }
                                                            return true
                                                        } else {
                                                            if (value) {
                                                                const numericValue = Number(value.replace(',', '.'))
                                                                console.log(
                                                                    'GGGG',
                                                                    value,
                                                                    numericValue,
                                                                    !isNaN(numericValue),
                                                                    questionKey
                                                                )
                                                                if (typeof min === 'number' && numericValue < min) {
                                                                    return this.createError({
                                                                        path: this.path,
                                                                        message: `${getTitle('9763', 'Minimum')} ${min}`,
                                                                    })
                                                                }
                                                                if (typeof max === 'number' && numericValue > max) {
                                                                    return this.createError({
                                                                        path: this.path,
                                                                        message: `${getTitle('9764', 'Maximum')} ${max}`,
                                                                    })
                                                                }
                                                                return !!value && !isNaN(numericValue)
                                                            }
                                                            return true // TODO FALSE - return test Error message getTitle('3924', 'Required field')
                                                        }
                                                    }
                                                    return true

                                                default:
                                                    return true
                                            }
                                            return true
                                        }
                                    })
                            }
                            acc[questionKey] = validateBaseCustomIntegerSchema()
                            break
                        default:
                            acc[questionKey] = Yup.string().max(1024, 'Maximum length 1024 characters').nullable()
                            if (question.required && !parent) {
                                acc[questionKey] = acc[questionKey].required(getTitle('3924', 'Required filed'))
                            }
                    }
                } else if (question.type === 'attribute') {
                    if (question.attribute.bool) {
                        const key = `bool_${questionKey}`
                        acc[key] = Yup.boolean().nullable()
                        if (question.required && !parent) {
                            acc[key] = acc[key].required(getTitle('3924', 'Required filed'))
                        }
                    }
                    if (question.attribute.checkbox) {
                        const key = `checkboxes_${questionKey}`
                        acc[key] = Yup.array()
                            .of(
                                Yup.object().shape({
                                    id: Yup.number().required(),
                                    rating: Yup.number().min(0).max(5).nullable(),
                                    checked: Yup.boolean(),
                                })
                            )
                            .nullable()
                            .test('at-least-one-checked', 'At least one item must be checked', function (value) {
                                if (!value && !parent) return false
                                // return value.some((item) => item.checked === true) // TODO
                                return true
                            })
                            .required(getTitle('3924', 'Required filed'))
                    }
                    if (question.attribute.date) {
                        const yearKey = `year_date_${questionKey}`
                        const monthKey = `month_date_${questionKey}`
                        const dayKey = `day_date_${questionKey}`

                        acc[yearKey] = Yup.string().nullable()
                        acc[monthKey] = Yup.string().nullable()
                        acc[dayKey] = Yup.string().nullable()

                        const validateDateCompleteness = () => {
                            return Yup.string()
                                .nullable()
                                .test('date-completeness', getTitle('148', 'Invalid date'), function (value) {
                                    const formValues = this.parent
                                    const year = formValues[yearKey]
                                    const month = formValues[monthKey]
                                    const day = formValues[dayKey]

                                    if (!year || !month || !day) {
                                        return true
                                    }

                                    const birthDate = new Date(Number(year), Number(month) - 1, Number(day))
                                    const isValid =
                                        birthDate.getFullYear() === Number(year) &&
                                        birthDate.getMonth() === Number(month) - 1 &&
                                        birthDate.getDate() === Number(day)

                                    return isValid
                                })
                                .test('date-completeness', getTitle('3924', 'Required field'), function (value) {
                                    const formValues = this.parent
                                    const year = formValues[yearKey]
                                    const month = formValues[monthKey]
                                    const day = formValues[dayKey]

                                    const hasPartialDate = !!year || !!month || !!day
                                    const hasCompleteDate = !!year && !!month && !!day

                                    if (question.required && !hasCompleteDate && !parent) {
                                        return this.createError({
                                            message: getTitle('3924', 'Required field'),
                                            path: this.path,
                                        })
                                    }

                                    if (hasPartialDate && !hasCompleteDate && !parent) {
                                        return this.createError({
                                            message: getTitle('3924', 'Required field'),
                                            path: this.path,
                                        })
                                    }

                                    return true
                                })
                        }

                        acc[yearKey] = validateDateCompleteness()
                        acc[monthKey] = validateDateCompleteness()
                        acc[dayKey] = validateDateCompleteness()

                        // acc[`year_date_${questionKey}`] = Yup.string().nullable()
                        // acc[`month_date_${questionKey}`] = Yup.string().nullable()
                        // acc[`day_date_${questionKey}`] = Yup.string().nullable()
                        //
                        // if (question.required) {
                        //     acc[`year_date_${questionKey}`] = acc[`year_date_${questionKey}`].required(
                        //         getTitle('6722', 'Year is required')
                        //     )
                        //     acc[`month_date_${questionKey}`] = acc[`month_date_${questionKey}`].required(
                        //         getTitle('6721', 'Month is required')
                        //     )
                        //     acc[`day_date_${questionKey}`] = acc[`day_date_${questionKey}`].required(
                        //         getTitle('10310', 'Day is required')
                        //     )
                        // }
                    }
                    if (question.attribute.shortText) {
                        const key = `shortText_${questionKey}`
                        acc[key] = Yup.string().max(1024, 'Maximum length 1024 characters').nullable()
                        if (question.required && !parent) {
                            acc[key] = acc[key].required('Short text required')
                        }
                    }
                    if (question.attribute.text) {
                        const key = `text_${questionKey}`
                        acc[key] = Yup.string().max(5000, 'Maximum length 5000 characters').nullable()
                        if (question.required && !parent) {
                            acc[key] = acc[key].required(getTitle('3924', 'Required filed'))
                        }
                    }
                    if (question.attribute.rating) {
                        const key = `rating_${questionKey}`
                        acc[key] = Yup.number().nullable()
                        if (question.required && !parent) {
                            acc[key] = acc[key].min(1).max(5).required(getTitle('3924', 'Required filed'))
                        }
                    }
                    if (question.attribute.dropdown) {
                        // const dropKey = `dropdown_${questionKey}`
                        const dropdownsKey = `dropdowns_${questionKey}`
                        // acc[dropdownsKey] = Yup.array().of(Yup.number())
                        // if (question.required) {
                        //     acc[dropdownsKey] = acc[dropdownsKey].min(1, 'Please select at least one option')
                        // }
                        acc[dropdownsKey] = Yup.number().nullable()
                        if (question.required && !parent) {
                            acc[dropdownsKey] = acc[dropdownsKey].required(getTitle('3924', 'Required filed'))
                        }
                    }
                } else {
                    switch (question.type) {
                        case 'multiSelect':
                            // acc[questionKey] = Yup.array().of(Yup.number()).nullable()
                            // if (question.required) {
                            //     acc[questionKey] = acc[questionKey]
                            //         .required(getTitle('3924', 'Required filed'))
                            //         .min(1, 'Please select at least one option')
                            // }
                            const validateBaseSimpleMultiSelectSchema = () => {
                                return Yup.array()
                                    .of(Yup.number())
                                    .nullable()
                                    .test(testBaseSchemaKey, getTitle('3924', 'Required field'), function (value) {
                                        if (!parent) {
                                            if (question.required) {
                                                return (
                                                    value !== null &&
                                                    value !== undefined &&
                                                    Array.isArray(value) &&
                                                    value.length > 0
                                                )
                                            } else {
                                                return true
                                            }
                                        }

                                        const formValues = this.parent
                                        switch (parent.type) {
                                            case 'customField':
                                                switch (parent.customField.typeId) {
                                                    case ApplyV2CustomFieldTypeConst.SingleSelect:
                                                        const [singleParentKey, singleParentValue] =
                                                            Object.entries(formValues).find(([key, value]) => {
                                                                if (key.includes(parent.questionId.toString())) {
                                                                    return true
                                                                }
                                                            }) ?? []

                                                        const isSingleShowCurrentValue =
                                                            singleParentValue === question.parentOptionId
                                                        if (isSingleShowCurrentValue && question.required) {
                                                            return (
                                                                value !== null &&
                                                                value !== undefined &&
                                                                Array.isArray(value) &&
                                                                value.length > 0
                                                            )
                                                        }
                                                        return true

                                                    case ApplyV2CustomFieldTypeConst.MultiSelect:
                                                        const [multiParentKey, multiParentValue] =
                                                            Object.entries(formValues).find(([key, value]) => {
                                                                if (key.includes(parent.questionId.toString())) {
                                                                    return true
                                                                }
                                                            }) ?? []

                                                        const isMultiShowCurrentValue =
                                                            Array.isArray(multiParentValue) &&
                                                            multiParentValue.includes(question.parentOptionId)

                                                        if (isMultiShowCurrentValue && question.required) {
                                                            return (
                                                                value !== null &&
                                                                value !== undefined &&
                                                                Array.isArray(value) &&
                                                                value.length > 0
                                                            )
                                                        }
                                                        return true
                                                    default:
                                                        return true
                                                }
                                            case 'multiSelect':
                                                const [multiParentKey, multiParentValue] =
                                                    Object.entries(formValues).find(([key, value]) => {
                                                        if (key.includes(parent.questionId.toString())) {
                                                            return true
                                                        }
                                                    }) ?? []

                                                const isMultiShowCurrentValue =
                                                    Array.isArray(multiParentValue) &&
                                                    multiParentValue.includes(question.parentOptionId)

                                                if (isMultiShowCurrentValue && question.required) {
                                                    return (
                                                        value !== null &&
                                                        value !== undefined &&
                                                        Array.isArray(value) &&
                                                        value.length > 0
                                                    )
                                                }
                                                return true
                                            case 'singleSelect':
                                            case 'yesNo':
                                            case 'qualifying':
                                                const [caseParentKey, caseParentValue] =
                                                    Object.entries(formValues).find(([key, value]) => {
                                                        if (key.includes(parent.questionId.toString())) {
                                                            return true
                                                        }
                                                    }) ?? []

                                                const isSingleShowCurrentValue =
                                                    caseParentValue === question.parentOptionId
                                                if (isSingleShowCurrentValue && question.required) {
                                                    return (
                                                        value !== null &&
                                                        value !== undefined &&
                                                        Array.isArray(value) &&
                                                        value.length > 0
                                                    )
                                                }
                                                return true

                                            default:
                                                return true
                                        }
                                    })
                            }
                            acc[questionKey] = validateBaseSimpleMultiSelectSchema()
                            break
                        case 'singleSelect':
                            // acc[questionKey] = Yup.number().nullable()
                            // if (question.required) {
                            //     acc[questionKey] = acc[questionKey].required(getTitle('3924', 'Required filed'))
                            // }
                            const validateBaseSimpleSingleSelectSchema = () => {
                                return Yup.number()
                                    .nullable()
                                    .nullable()
                                    .test(testBaseSchemaKey, getTitle('3924', 'Required field'), function (value) {
                                        if (!parent) {
                                            if (question.required) {
                                                return value !== null && value !== undefined
                                            } else {
                                                return true
                                            }
                                        }

                                        const formValues = this.parent
                                        switch (parent.type) {
                                            case 'customField':
                                                switch (parent.customField.typeId) {
                                                    case ApplyV2CustomFieldTypeConst.SingleSelect:
                                                        const [singleParentKey, singleParentValue] =
                                                            Object.entries(formValues).find(([key, value]) => {
                                                                if (key.includes(parent.questionId.toString())) {
                                                                    return true
                                                                }
                                                            }) ?? []

                                                        const isSingleShowCurrentValue =
                                                            singleParentValue === question.parentOptionId
                                                        if (isSingleShowCurrentValue && question.required) {
                                                            return value !== null && value !== undefined
                                                        }
                                                        return true

                                                    case ApplyV2CustomFieldTypeConst.MultiSelect:
                                                        const [multiParentKey, multiParentValue] =
                                                            Object.entries(formValues).find(([key, value]) => {
                                                                if (key.includes(parent.questionId.toString())) {
                                                                    return true
                                                                }
                                                            }) ?? []

                                                        const isMultiShowCurrentValue =
                                                            Array.isArray(multiParentValue) &&
                                                            multiParentValue.includes(question.parentOptionId)

                                                        if (isMultiShowCurrentValue && question.required) {
                                                            return (
                                                                value !== null &&
                                                                value !== undefined &&
                                                                Array.isArray(value)
                                                            )
                                                        }
                                                        return true
                                                    default:
                                                        return true
                                                }
                                            case 'multiSelect':
                                                const [multiParentKey, multiParentValue] =
                                                    Object.entries(formValues).find(([key, value]) => {
                                                        if (key.includes(parent.questionId.toString())) {
                                                            return true
                                                        }
                                                    }) ?? []

                                                const isMultiShowCurrentValue =
                                                    Array.isArray(multiParentValue) &&
                                                    multiParentValue.includes(question.parentOptionId)

                                                if (isMultiShowCurrentValue && question.required) {
                                                    return value !== null && value !== undefined
                                                }
                                                return true
                                            case 'singleSelect':
                                            case 'yesNo':
                                            case 'qualifying':
                                                const [caseParentKey, caseParentValue] =
                                                    Object.entries(formValues).find(([key, value]) => {
                                                        if (key.includes(parent.questionId.toString())) {
                                                            return true
                                                        }
                                                    }) ?? []

                                                const isSingleShowCurrentValue =
                                                    caseParentValue === question.parentOptionId
                                                if (isSingleShowCurrentValue && question.required) {
                                                    return value !== null && value !== undefined
                                                }
                                                return true

                                            default:
                                                return true
                                        }
                                    })
                            }
                            acc[questionKey] = validateBaseSimpleSingleSelectSchema()
                            break
                        case 'date':
                            const yearDateCustomField = `year_${questionKey}`
                            const monthDateCustomField = `month_${questionKey}`
                            const dayDateCustomField = `day_${questionKey}`

                            const validateBaseSimpleYearDateSchema = () => {
                                return Yup.string()
                                    .nullable()
                                    .test(testBaseSchemaKey, getTitle('148', 'Invalid date'), function (value) {
                                        const formValues = this.parent
                                        const startYear = formValues[yearDateCustomField]
                                        const startMonth = formValues[monthDateCustomField]
                                        const startDay = formValues[dayDateCustomField]

                                        if (!startYear || !startMonth || !startDay) {
                                            return true
                                        }

                                        const birthDate = new Date(
                                            Number(startYear),
                                            Number(startMonth) - 1,
                                            Number(startDay)
                                        )

                                        const isValid =
                                            birthDate.getFullYear() === Number(startYear) &&
                                            birthDate.getMonth() === Number(startMonth) - 1 &&
                                            birthDate.getDate() === Number(startDay)

                                        return isValid
                                    })
                                    .test(testBaseSchemaKey, function (value) {
                                        const formValues = this.parent
                                        const startYear = formValues[yearDateCustomField]
                                        const startMonth = formValues[monthDateCustomField]
                                        const startDay = formValues[dayDateCustomField]

                                        if (!parent) {
                                            if (question.required) {
                                                const errors = []
                                                if (!startYear) {
                                                    errors.push({
                                                        message: getTitle('6722', 'Year is required'),
                                                        field: yearDateCustomField,
                                                    })
                                                }
                                                if (!startMonth) {
                                                    errors.push({
                                                        message: getTitle('6721', 'Month is required'),
                                                        field: monthDateCustomField,
                                                    })
                                                }
                                                if (!startDay) {
                                                    errors.push({
                                                        message: getTitle('10310', 'Day is required'),
                                                        field: dayDateCustomField,
                                                    })
                                                }

                                                if (errors.length > 0) {
                                                    console.log(errors)
                                                    errors.forEach((error) => {
                                                        if (this.path !== error.field) {
                                                            this.createError({
                                                                message: error.message,
                                                                path: error.field,
                                                            })
                                                        }
                                                    })

                                                    const currentFieldError = errors.find(
                                                        (error) => error.field === this.path
                                                    )
                                                    if (currentFieldError) {
                                                        return this.createError({
                                                            message: currentFieldError.message,
                                                            path: this.path,
                                                        })
                                                    }
                                                }
                                                console.log(errors)
                                                return true
                                                // return errors.length !== 0
                                            } else {
                                                return true
                                            }
                                            return true
                                        }

                                        switch (parent.type) {
                                            case 'customField':
                                                switch (parent.customField.typeId) {
                                                    case ApplyV2CustomFieldTypeConst.SingleSelect:
                                                        const [singleParentKey, singleParentValue] =
                                                            Object.entries(formValues).find(([key, value]) => {
                                                                if (key.includes(parent.questionId.toString())) {
                                                                    return true
                                                                }
                                                            }) ?? []

                                                        const isSingleShowCurrentValue =
                                                            singleParentValue === question.parentOptionId
                                                        if (isSingleShowCurrentValue) {
                                                            if (question.required) {
                                                                const errors = []
                                                                if (!startYear) {
                                                                    errors.push({
                                                                        message: getTitle('6722', 'Year is required'),
                                                                        field: yearDateCustomField,
                                                                    })
                                                                }
                                                                if (!startMonth) {
                                                                    errors.push({
                                                                        message: getTitle('6721', 'Month is required'),
                                                                        field: monthDateCustomField,
                                                                    })
                                                                }
                                                                if (!startDay) {
                                                                    errors.push({
                                                                        message: getTitle('10310', 'Day is required'),
                                                                        field: dayDateCustomField,
                                                                    })
                                                                }

                                                                if (errors.length > 0) {
                                                                    errors.forEach((error) => {
                                                                        if (this.path !== error.field) {
                                                                            this.createError({
                                                                                message: error.message,
                                                                                path: error.field,
                                                                            })
                                                                        }
                                                                    })

                                                                    const currentFieldError = errors.find(
                                                                        (error) => error.field === this.path
                                                                    )
                                                                    if (currentFieldError) {
                                                                        return this.createError({
                                                                            message: currentFieldError.message,
                                                                            path: this.path,
                                                                        })
                                                                    }
                                                                }

                                                                return errors.length > 0
                                                            }
                                                            return true
                                                        }
                                                        return true

                                                    case ApplyV2CustomFieldTypeConst.MultiSelect:
                                                        const [multiParentKey, multiParentValue] =
                                                            Object.entries(formValues).find(([key, value]) => {
                                                                if (key.includes(parent.questionId.toString())) {
                                                                    return true
                                                                }
                                                            }) ?? []

                                                        const isMultiShowCurrentValue =
                                                            Array.isArray(multiParentValue) &&
                                                            multiParentValue.includes(question.parentOptionId)

                                                        if (isMultiShowCurrentValue) {
                                                            if (question.required) {
                                                                const errors = []
                                                                if (!startYear) {
                                                                    errors.push({
                                                                        message: getTitle('6722', 'Year is required'),
                                                                        field: yearDateCustomField,
                                                                    })
                                                                }
                                                                if (!startMonth) {
                                                                    errors.push({
                                                                        message: getTitle('6721', 'Month is required'),
                                                                        field: monthDateCustomField,
                                                                    })
                                                                }
                                                                if (!startDay) {
                                                                    errors.push({
                                                                        message: getTitle('10310', 'Day is required'),
                                                                        field: dayDateCustomField,
                                                                    })
                                                                }

                                                                if (errors.length > 0) {
                                                                    errors.forEach((error) => {
                                                                        if (this.path !== error.field) {
                                                                            this.createError({
                                                                                message: error.message,
                                                                                path: error.field,
                                                                            })
                                                                        }
                                                                    })

                                                                    const currentFieldError = errors.find(
                                                                        (error) => error.field === this.path
                                                                    )
                                                                    if (currentFieldError) {
                                                                        return this.createError({
                                                                            message: currentFieldError.message,
                                                                            path: this.path,
                                                                        })
                                                                    }
                                                                }

                                                                return errors.length > 0
                                                            }
                                                            return true
                                                        }
                                                        return true
                                                    default:
                                                        return true
                                                }
                                            case 'multiSelect':
                                                const [multiParentKey, multiParentValue] =
                                                    Object.entries(formValues).find(([key, value]) => {
                                                        if (key.includes(parent.questionId.toString())) {
                                                            return true
                                                        }
                                                    }) ?? []

                                                const isMultiShowCurrentValue =
                                                    Array.isArray(multiParentValue) &&
                                                    multiParentValue.includes(question.parentOptionId)

                                                if (isMultiShowCurrentValue) {
                                                    if (question.required) {
                                                        const errors = []
                                                        if (!startYear) {
                                                            errors.push({
                                                                message: getTitle('6722', 'Year is required'),
                                                                field: yearDateCustomField,
                                                            })
                                                        }
                                                        if (!startMonth) {
                                                            errors.push({
                                                                message: getTitle('6721', 'Month is required'),
                                                                field: monthDateCustomField,
                                                            })
                                                        }
                                                        if (!startDay) {
                                                            errors.push({
                                                                message: getTitle('10310', 'Day is required'),
                                                                field: dayDateCustomField,
                                                            })
                                                        }

                                                        if (errors.length > 0) {
                                                            errors.forEach((error) => {
                                                                if (this.path !== error.field) {
                                                                    this.createError({
                                                                        message: error.message,
                                                                        path: error.field,
                                                                    })
                                                                }
                                                            })

                                                            const currentFieldError = errors.find(
                                                                (error) => error.field === this.path
                                                            )
                                                            if (currentFieldError) {
                                                                return this.createError({
                                                                    message: currentFieldError.message,
                                                                    path: this.path,
                                                                })
                                                            }
                                                        }

                                                        return errors.length > 0
                                                    }
                                                    return true
                                                }
                                                return true
                                            case 'singleSelect':
                                            case 'yesNo':
                                            case 'qualifying':
                                                const [caseParentKey, caseParentValue] =
                                                    Object.entries(formValues).find(([key, value]) => {
                                                        if (key.includes(parent.questionId.toString())) {
                                                            return true
                                                        }
                                                    }) ?? []

                                                const isSingleShowCurrentValue =
                                                    caseParentValue === question.parentOptionId
                                                if (isSingleShowCurrentValue) {
                                                    if (question.required) {
                                                        const errors = []
                                                        if (!startYear) {
                                                            errors.push({
                                                                message: getTitle('6722', 'Year is required'),
                                                                field: yearDateCustomField,
                                                            })
                                                        }
                                                        if (!startMonth) {
                                                            errors.push({
                                                                message: getTitle('6721', 'Month is required'),
                                                                field: monthDateCustomField,
                                                            })
                                                        }
                                                        if (!startDay) {
                                                            errors.push({
                                                                message: getTitle('10310', 'Day is required'),
                                                                field: dayDateCustomField,
                                                            })
                                                        }

                                                        if (errors.length > 0) {
                                                            errors.forEach((error) => {
                                                                if (this.path !== error.field) {
                                                                    this.createError({
                                                                        message: error.message,
                                                                        path: error.field,
                                                                    })
                                                                }
                                                            })

                                                            const currentFieldError = errors.find(
                                                                (error) => error.field === this.path
                                                            )
                                                            if (currentFieldError) {
                                                                return this.createError({
                                                                    message: currentFieldError.message,
                                                                    path: this.path,
                                                                })
                                                            }
                                                        }

                                                        return errors.length === 0
                                                    }
                                                    return true
                                                }
                                                return true

                                            default:
                                                return true
                                        }
                                    })
                            }

                            acc[yearDateCustomField] = validateBaseSimpleYearDateSchema()
                            acc[monthDateCustomField] = validateBaseSimpleYearDateSchema()
                            acc[dayDateCustomField] = validateBaseSimpleYearDateSchema()
                            break
                        case 'dateRange':
                            const startYearKey = `startYear_${questionKey}`
                            const startMonthKey = `startMonth_${questionKey}`
                            const startDayKey = `startDay_${questionKey}`
                            const endYearKey = `endYear_${questionKey}`
                            const endMonthKey = `endMonth_${questionKey}`
                            const endDayKey = `endDay_${questionKey}`

                            const validateBaseSimpleStartRangeDateSchema = () => {
                                return Yup.string()
                                    .nullable()
                                    .test(testBaseSchemaKey, function (value) {
                                        const formValues = this.parent
                                        const startYear = formValues[startYearKey]
                                        const startMonth = formValues[startMonthKey]
                                        const startDay = formValues[startDayKey]
                                        const endYear = formValues[endYearKey]
                                        const endMonth = formValues[endMonthKey]
                                        const endDay = formValues[endDayKey]

                                        const isStartDateComplete = !!startYear && !!startMonth && !!startDay
                                        const isEndDateComplete = !!endYear && !!endMonth && !!endDay

                                        if (!parent) {
                                            if (question.required) {
                                                const errors = []
                                                if (!startYear) {
                                                    errors.push({
                                                        message: getTitle('6722', 'Year is required'),
                                                        field: startYearKey,
                                                    })
                                                }
                                                if (!startMonth) {
                                                    errors.push({
                                                        message: getTitle('6721', 'Month is required'),
                                                        field: startMonthKey,
                                                    })
                                                }
                                                if (!startDay) {
                                                    errors.push({
                                                        message: getTitle('10310', 'Day is required'),
                                                        field: startDayKey,
                                                    })
                                                }
                                                if (!endYear) {
                                                    errors.push({
                                                        message: getTitle('6722', 'Year is required'),
                                                        field: endYearKey,
                                                    })
                                                }
                                                if (!endMonth) {
                                                    errors.push({
                                                        message: getTitle('6721', 'Month is required'),
                                                        field: endMonthKey,
                                                    })
                                                }
                                                if (!endDay) {
                                                    errors.push({
                                                        message: getTitle('10310', 'Day is required'),
                                                        field: endDayKey,
                                                    })
                                                }

                                                if (isEndDateComplete && isStartDateComplete) {
                                                    try {
                                                        const startDate = dayjs()
                                                            .year(parseInt(startYear))
                                                            .month(parseInt(startMonth) - 1)
                                                            .date(parseInt(startDay))
                                                            .startOf('day')

                                                        const endDate = dayjs()
                                                            .year(parseInt(endYear))
                                                            .month(parseInt(endMonth) - 1)
                                                            .date(parseInt(endDay))
                                                            .startOf('day')

                                                        if (
                                                            startDate.isValid() &&
                                                            endDate.isValid() &&
                                                            endDate.isBefore(startDate)
                                                        ) {
                                                            errors.push({
                                                                message: getTitle(
                                                                    '9453',
                                                                    'End date cannot be earlier than start date'
                                                                ),
                                                                field: endDayKey,
                                                            })
                                                            errors.push({
                                                                message: getTitle(
                                                                    '9453',
                                                                    'End date cannot be earlier than start date'
                                                                ),
                                                                field: endMonthKey,
                                                            })
                                                            errors.push({
                                                                message: getTitle(
                                                                    '9453',
                                                                    'End date cannot be earlier than start date'
                                                                ),
                                                                field: endYearKey,
                                                            })
                                                        }

                                                        // return true
                                                    } catch (error) {
                                                        console.error('Date validation error:', error)
                                                        return true
                                                    }
                                                }
                                                if (errors.length > 0) {
                                                    errors.forEach((error) => {
                                                        if (this.path !== error.field) {
                                                            this.createError({
                                                                message: error.message,
                                                                path: error.field,
                                                            })
                                                        }
                                                    })

                                                    const currentFieldError = errors.find(
                                                        (error) => error.field === this.path
                                                    )
                                                    if (currentFieldError) {
                                                        console.log('currentFieldError', currentFieldError)
                                                        return this.createError({
                                                            message: currentFieldError.message,
                                                            path: this.path,
                                                        })
                                                    }
                                                }
                                                console.log(errors.length, errors)
                                                return true
                                                // return errors.length > 0
                                            } else {
                                                const errors = []
                                                if (isEndDateComplete && isStartDateComplete) {
                                                    try {
                                                        const startDate = dayjs()
                                                            .year(parseInt(startYear))
                                                            .month(parseInt(startMonth) - 1)
                                                            .date(parseInt(startDay))
                                                            .startOf('day')

                                                        const endDate = dayjs()
                                                            .year(parseInt(endYear))
                                                            .month(parseInt(endMonth) - 1)
                                                            .date(parseInt(endDay))
                                                            .startOf('day')

                                                        if (
                                                            startDate.isValid() &&
                                                            endDate.isValid() &&
                                                            endDate.isBefore(startDate)
                                                        ) {
                                                            errors.push({
                                                                message: getTitle(
                                                                    '9453',
                                                                    'End date cannot be earlier than start date'
                                                                ),
                                                                field: endDayKey,
                                                            })
                                                            errors.push({
                                                                message: getTitle(
                                                                    '9453',
                                                                    'End date cannot be earlier than start date'
                                                                ),
                                                                field: endMonthKey,
                                                            })
                                                            errors.push({
                                                                message: getTitle(
                                                                    '9453',
                                                                    'End date cannot be earlier than start date'
                                                                ),
                                                                field: endYearKey,
                                                            })
                                                        }

                                                        // return true
                                                    } catch (error) {
                                                        console.error('Date validation error:', error)
                                                        return true
                                                    }
                                                }
                                                if (errors.length > 0) {
                                                    errors.forEach((error) => {
                                                        if (this.path !== error.field) {
                                                            this.createError({
                                                                message: error.message,
                                                                path: error.field,
                                                            })
                                                        }
                                                    })

                                                    const currentFieldError = errors.find(
                                                        (error) => error.field === this.path
                                                    )
                                                    if (currentFieldError) {
                                                        console.log('currentFieldError', currentFieldError)
                                                        return this.createError({
                                                            message: currentFieldError.message,
                                                            path: this.path,
                                                        })
                                                    }
                                                }
                                                return true
                                            }
                                        } else {
                                            switch (parent.type) {
                                                case 'customField':
                                                    switch (parent.customField.typeId) {
                                                        case ApplyV2CustomFieldTypeConst.SingleSelect:
                                                            const [singleParentKey, singleParentValue] =
                                                                Object.entries(formValues).find(([key, value]) => {
                                                                    if (key.includes(parent.questionId.toString())) {
                                                                        return true
                                                                    }
                                                                }) ?? []

                                                            const isSingleShowCurrentValue =
                                                                singleParentValue === question.parentOptionId
                                                            if (isSingleShowCurrentValue) {
                                                                if (question.required) {
                                                                    const errors = []
                                                                    if (!startYear) {
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '6722',
                                                                                'Year is required'
                                                                            ),
                                                                            field: startYearKey,
                                                                        })
                                                                    }
                                                                    if (!startMonth) {
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '6721',
                                                                                'Month is required'
                                                                            ),
                                                                            field: startMonthKey,
                                                                        })
                                                                    }
                                                                    if (!startDay) {
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '10310',
                                                                                'Day is required'
                                                                            ),
                                                                            field: startDayKey,
                                                                        })
                                                                    }
                                                                    if (!endYear) {
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '6722',
                                                                                'Year is required'
                                                                            ),
                                                                            field: endYearKey,
                                                                        })
                                                                    }
                                                                    if (!endMonth) {
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '6721',
                                                                                'Month is required'
                                                                            ),
                                                                            field: endMonthKey,
                                                                        })
                                                                    }
                                                                    if (!endDay) {
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '10310',
                                                                                'Day is required'
                                                                            ),
                                                                            field: endDayKey,
                                                                        })
                                                                    }

                                                                    if (isEndDateComplete && isStartDateComplete) {
                                                                        try {
                                                                            const startDate = dayjs()
                                                                                .year(parseInt(startYear))
                                                                                .month(parseInt(startMonth) - 1)
                                                                                .date(parseInt(startDay))
                                                                                .startOf('day')

                                                                            const endDate = dayjs()
                                                                                .year(parseInt(endYear))
                                                                                .month(parseInt(endMonth) - 1)
                                                                                .date(parseInt(endDay))
                                                                                .startOf('day')

                                                                            if (
                                                                                startDate.isValid() &&
                                                                                endDate.isValid() &&
                                                                                endDate.isBefore(startDate)
                                                                            ) {
                                                                                errors.push({
                                                                                    message: getTitle(
                                                                                        '9453',
                                                                                        'End date cannot be earlier than start date'
                                                                                    ),
                                                                                    field: endDayKey,
                                                                                })
                                                                                errors.push({
                                                                                    message: getTitle(
                                                                                        '9453',
                                                                                        'End date cannot be earlier than start date'
                                                                                    ),
                                                                                    field: endMonthKey,
                                                                                })
                                                                                errors.push({
                                                                                    message: getTitle(
                                                                                        '9453',
                                                                                        'End date cannot be earlier than start date'
                                                                                    ),
                                                                                    field: endYearKey,
                                                                                })
                                                                            }

                                                                            // return true
                                                                        } catch (error) {
                                                                            console.error(
                                                                                'Date validation error:',
                                                                                error
                                                                            )
                                                                            return true
                                                                        }
                                                                    }
                                                                    if (errors.length > 0) {
                                                                        errors.forEach((error) => {
                                                                            if (this.path !== error.field) {
                                                                                this.createError({
                                                                                    message: error.message,
                                                                                    path: error.field,
                                                                                })
                                                                            }
                                                                        })

                                                                        const currentFieldError = errors.find(
                                                                            (error) => error.field === this.path
                                                                        )
                                                                        if (currentFieldError) {
                                                                            console.log(
                                                                                'currentFieldError',
                                                                                currentFieldError
                                                                            )
                                                                            return this.createError({
                                                                                message: currentFieldError.message,
                                                                                path: this.path,
                                                                            })
                                                                        }
                                                                    }
                                                                    console.log(errors.length, errors)
                                                                    return true
                                                                    // return errors.length > 0
                                                                } else {
                                                                    const errors = []
                                                                    if (isEndDateComplete && isStartDateComplete) {
                                                                        try {
                                                                            const startDate = dayjs()
                                                                                .year(parseInt(startYear))
                                                                                .month(parseInt(startMonth) - 1)
                                                                                .date(parseInt(startDay))
                                                                                .startOf('day')

                                                                            const endDate = dayjs()
                                                                                .year(parseInt(endYear))
                                                                                .month(parseInt(endMonth) - 1)
                                                                                .date(parseInt(endDay))
                                                                                .startOf('day')

                                                                            if (
                                                                                startDate.isValid() &&
                                                                                endDate.isValid() &&
                                                                                endDate.isBefore(startDate)
                                                                            ) {
                                                                                errors.push({
                                                                                    message: getTitle(
                                                                                        '9453',
                                                                                        'End date cannot be earlier than start date'
                                                                                    ),
                                                                                    field: endDayKey,
                                                                                })
                                                                                errors.push({
                                                                                    message: getTitle(
                                                                                        '9453',
                                                                                        'End date cannot be earlier than start date'
                                                                                    ),
                                                                                    field: endMonthKey,
                                                                                })
                                                                                errors.push({
                                                                                    message: getTitle(
                                                                                        '9453',
                                                                                        'End date cannot be earlier than start date'
                                                                                    ),
                                                                                    field: endYearKey,
                                                                                })
                                                                            }

                                                                            // return true
                                                                        } catch (error) {
                                                                            console.error(
                                                                                'Date validation error:',
                                                                                error
                                                                            )
                                                                            return true
                                                                        }
                                                                    }
                                                                    if (errors.length > 0) {
                                                                        errors.forEach((error) => {
                                                                            if (this.path !== error.field) {
                                                                                this.createError({
                                                                                    message: error.message,
                                                                                    path: error.field,
                                                                                })
                                                                            }
                                                                        })

                                                                        const currentFieldError = errors.find(
                                                                            (error) => error.field === this.path
                                                                        )
                                                                        if (currentFieldError) {
                                                                            console.log(
                                                                                'currentFieldError',
                                                                                currentFieldError
                                                                            )
                                                                            return this.createError({
                                                                                message: currentFieldError.message,
                                                                                path: this.path,
                                                                            })
                                                                        }
                                                                    }
                                                                    return true
                                                                }
                                                            }
                                                            return true

                                                        case ApplyV2CustomFieldTypeConst.MultiSelect:
                                                            const [multiParentKey, multiParentValue] =
                                                                Object.entries(formValues).find(([key, value]) => {
                                                                    if (key.includes(parent.questionId.toString())) {
                                                                        return true
                                                                    }
                                                                }) ?? []

                                                            const isMultiShowCurrentValue =
                                                                Array.isArray(multiParentValue) &&
                                                                multiParentValue.includes(question.parentOptionId)

                                                            if (isMultiShowCurrentValue) {
                                                                if (question.required) {
                                                                    const errors = []
                                                                    if (!startYear) {
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '6722',
                                                                                'Year is required'
                                                                            ),
                                                                            field: startYearKey,
                                                                        })
                                                                    }
                                                                    if (!startMonth) {
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '6721',
                                                                                'Month is required'
                                                                            ),
                                                                            field: startMonthKey,
                                                                        })
                                                                    }
                                                                    if (!startDay) {
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '10310',
                                                                                'Day is required'
                                                                            ),
                                                                            field: startDayKey,
                                                                        })
                                                                    }
                                                                    if (!endYear) {
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '6722',
                                                                                'Year is required'
                                                                            ),
                                                                            field: endYearKey,
                                                                        })
                                                                    }
                                                                    if (!endMonth) {
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '6721',
                                                                                'Month is required'
                                                                            ),
                                                                            field: endMonthKey,
                                                                        })
                                                                    }
                                                                    if (!endDay) {
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '10310',
                                                                                'Day is required'
                                                                            ),
                                                                            field: endDayKey,
                                                                        })
                                                                    }

                                                                    if (isEndDateComplete && isStartDateComplete) {
                                                                        try {
                                                                            const startDate = dayjs()
                                                                                .year(parseInt(startYear))
                                                                                .month(parseInt(startMonth) - 1)
                                                                                .date(parseInt(startDay))
                                                                                .startOf('day')

                                                                            const endDate = dayjs()
                                                                                .year(parseInt(endYear))
                                                                                .month(parseInt(endMonth) - 1)
                                                                                .date(parseInt(endDay))
                                                                                .startOf('day')

                                                                            if (
                                                                                startDate.isValid() &&
                                                                                endDate.isValid() &&
                                                                                endDate.isBefore(startDate)
                                                                            ) {
                                                                                errors.push({
                                                                                    message: getTitle(
                                                                                        '9453',
                                                                                        'End date cannot be earlier than start date'
                                                                                    ),
                                                                                    field: endDayKey,
                                                                                })
                                                                                errors.push({
                                                                                    message: getTitle(
                                                                                        '9453',
                                                                                        'End date cannot be earlier than start date'
                                                                                    ),
                                                                                    field: endMonthKey,
                                                                                })
                                                                                errors.push({
                                                                                    message: getTitle(
                                                                                        '9453',
                                                                                        'End date cannot be earlier than start date'
                                                                                    ),
                                                                                    field: endYearKey,
                                                                                })
                                                                            }

                                                                            // return true
                                                                        } catch (error) {
                                                                            console.error(
                                                                                'Date validation error:',
                                                                                error
                                                                            )
                                                                            return true
                                                                        }
                                                                    }
                                                                    if (errors.length > 0) {
                                                                        errors.forEach((error) => {
                                                                            if (this.path !== error.field) {
                                                                                this.createError({
                                                                                    message: error.message,
                                                                                    path: error.field,
                                                                                })
                                                                            }
                                                                        })

                                                                        const currentFieldError = errors.find(
                                                                            (error) => error.field === this.path
                                                                        )
                                                                        if (currentFieldError) {
                                                                            console.log(
                                                                                'currentFieldError',
                                                                                currentFieldError
                                                                            )
                                                                            return this.createError({
                                                                                message: currentFieldError.message,
                                                                                path: this.path,
                                                                            })
                                                                        }
                                                                    }
                                                                    console.log(errors.length, errors)
                                                                    return true
                                                                    // return errors.length > 0
                                                                } else {
                                                                    const errors = []
                                                                    if (isEndDateComplete && isStartDateComplete) {
                                                                        try {
                                                                            const startDate = dayjs()
                                                                                .year(parseInt(startYear))
                                                                                .month(parseInt(startMonth) - 1)
                                                                                .date(parseInt(startDay))
                                                                                .startOf('day')

                                                                            const endDate = dayjs()
                                                                                .year(parseInt(endYear))
                                                                                .month(parseInt(endMonth) - 1)
                                                                                .date(parseInt(endDay))
                                                                                .startOf('day')

                                                                            if (
                                                                                startDate.isValid() &&
                                                                                endDate.isValid() &&
                                                                                endDate.isBefore(startDate)
                                                                            ) {
                                                                                errors.push({
                                                                                    message: getTitle(
                                                                                        '9453',
                                                                                        'End date cannot be earlier than start date'
                                                                                    ),
                                                                                    field: endDayKey,
                                                                                })
                                                                                errors.push({
                                                                                    message: getTitle(
                                                                                        '9453',
                                                                                        'End date cannot be earlier than start date'
                                                                                    ),
                                                                                    field: endMonthKey,
                                                                                })
                                                                                errors.push({
                                                                                    message: getTitle(
                                                                                        '9453',
                                                                                        'End date cannot be earlier than start date'
                                                                                    ),
                                                                                    field: endYearKey,
                                                                                })
                                                                            }

                                                                            // return true
                                                                        } catch (error) {
                                                                            console.error(
                                                                                'Date validation error:',
                                                                                error
                                                                            )
                                                                            return true
                                                                        }
                                                                    }
                                                                    if (errors.length > 0) {
                                                                        errors.forEach((error) => {
                                                                            if (this.path !== error.field) {
                                                                                this.createError({
                                                                                    message: error.message,
                                                                                    path: error.field,
                                                                                })
                                                                            }
                                                                        })

                                                                        const currentFieldError = errors.find(
                                                                            (error) => error.field === this.path
                                                                        )
                                                                        if (currentFieldError) {
                                                                            console.log(
                                                                                'currentFieldError',
                                                                                currentFieldError
                                                                            )
                                                                            return this.createError({
                                                                                message: currentFieldError.message,
                                                                                path: this.path,
                                                                            })
                                                                        }
                                                                    }
                                                                    return true
                                                                }
                                                            }
                                                            return true
                                                        default:
                                                            return true
                                                    }
                                                case 'multiSelect':
                                                    const [multiParentKey, multiParentValue] =
                                                        Object.entries(formValues).find(([key, value]) => {
                                                            if (key.includes(parent.questionId.toString())) {
                                                                return true
                                                            }
                                                        }) ?? []

                                                    const isMultiShowCurrentValue =
                                                        Array.isArray(multiParentValue) &&
                                                        multiParentValue.includes(question.parentOptionId)

                                                    if (isMultiShowCurrentValue) {
                                                        if (question.required) {
                                                            const errors = []
                                                            if (!startYear) {
                                                                errors.push({
                                                                    message: getTitle('6722', 'Year is required'),
                                                                    field: startYearKey,
                                                                })
                                                            }
                                                            if (!startMonth) {
                                                                errors.push({
                                                                    message: getTitle('6721', 'Month is required'),
                                                                    field: startMonthKey,
                                                                })
                                                            }
                                                            if (!startDay) {
                                                                errors.push({
                                                                    message: getTitle('10310', 'Day is required'),
                                                                    field: startDayKey,
                                                                })
                                                            }
                                                            if (!endYear) {
                                                                errors.push({
                                                                    message: getTitle('6722', 'Year is required'),
                                                                    field: endYearKey,
                                                                })
                                                            }
                                                            if (!endMonth) {
                                                                errors.push({
                                                                    message: getTitle('6721', 'Month is required'),
                                                                    field: endMonthKey,
                                                                })
                                                            }
                                                            if (!endDay) {
                                                                errors.push({
                                                                    message: getTitle('10310', 'Day is required'),
                                                                    field: endDayKey,
                                                                })
                                                            }

                                                            if (isEndDateComplete && isStartDateComplete) {
                                                                try {
                                                                    const startDate = dayjs()
                                                                        .year(parseInt(startYear))
                                                                        .month(parseInt(startMonth) - 1)
                                                                        .date(parseInt(startDay))
                                                                        .startOf('day')

                                                                    const endDate = dayjs()
                                                                        .year(parseInt(endYear))
                                                                        .month(parseInt(endMonth) - 1)
                                                                        .date(parseInt(endDay))
                                                                        .startOf('day')

                                                                    if (
                                                                        startDate.isValid() &&
                                                                        endDate.isValid() &&
                                                                        endDate.isBefore(startDate)
                                                                    ) {
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '9453',
                                                                                'End date cannot be earlier than start date'
                                                                            ),
                                                                            field: endDayKey,
                                                                        })
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '9453',
                                                                                'End date cannot be earlier than start date'
                                                                            ),
                                                                            field: endMonthKey,
                                                                        })
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '9453',
                                                                                'End date cannot be earlier than start date'
                                                                            ),
                                                                            field: endYearKey,
                                                                        })
                                                                    }

                                                                    // return true
                                                                } catch (error) {
                                                                    console.error('Date validation error:', error)
                                                                    return true
                                                                }
                                                            }
                                                            if (errors.length > 0) {
                                                                errors.forEach((error) => {
                                                                    if (this.path !== error.field) {
                                                                        this.createError({
                                                                            message: error.message,
                                                                            path: error.field,
                                                                        })
                                                                    }
                                                                })

                                                                const currentFieldError = errors.find(
                                                                    (error) => error.field === this.path
                                                                )
                                                                if (currentFieldError) {
                                                                    console.log('currentFieldError', currentFieldError)
                                                                    return this.createError({
                                                                        message: currentFieldError.message,
                                                                        path: this.path,
                                                                    })
                                                                }
                                                            }
                                                            console.log(errors.length, errors)
                                                            return true
                                                            // return errors.length > 0
                                                        } else {
                                                            const errors = []
                                                            if (isEndDateComplete && isStartDateComplete) {
                                                                try {
                                                                    const startDate = dayjs()
                                                                        .year(parseInt(startYear))
                                                                        .month(parseInt(startMonth) - 1)
                                                                        .date(parseInt(startDay))
                                                                        .startOf('day')

                                                                    const endDate = dayjs()
                                                                        .year(parseInt(endYear))
                                                                        .month(parseInt(endMonth) - 1)
                                                                        .date(parseInt(endDay))
                                                                        .startOf('day')

                                                                    if (
                                                                        startDate.isValid() &&
                                                                        endDate.isValid() &&
                                                                        endDate.isBefore(startDate)
                                                                    ) {
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '9453',
                                                                                'End date cannot be earlier than start date'
                                                                            ),
                                                                            field: endDayKey,
                                                                        })
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '9453',
                                                                                'End date cannot be earlier than start date'
                                                                            ),
                                                                            field: endMonthKey,
                                                                        })
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '9453',
                                                                                'End date cannot be earlier than start date'
                                                                            ),
                                                                            field: endYearKey,
                                                                        })
                                                                    }

                                                                    // return true
                                                                } catch (error) {
                                                                    console.error('Date validation error:', error)
                                                                    return true
                                                                }
                                                            }
                                                            if (errors.length > 0) {
                                                                errors.forEach((error) => {
                                                                    if (this.path !== error.field) {
                                                                        this.createError({
                                                                            message: error.message,
                                                                            path: error.field,
                                                                        })
                                                                    }
                                                                })

                                                                const currentFieldError = errors.find(
                                                                    (error) => error.field === this.path
                                                                )
                                                                if (currentFieldError) {
                                                                    console.log('currentFieldError', currentFieldError)
                                                                    return this.createError({
                                                                        message: currentFieldError.message,
                                                                        path: this.path,
                                                                    })
                                                                }
                                                            }
                                                            return true
                                                        }
                                                    }
                                                    return true
                                                case 'singleSelect':
                                                case 'yesNo':
                                                case 'qualifying':
                                                    const [caseParentKey, caseParentValue] =
                                                        Object.entries(formValues).find(([key, value]) => {
                                                            if (key.includes(parent.questionId.toString())) {
                                                                return true
                                                            }
                                                        }) ?? []

                                                    const isSingleShowCurrentValue =
                                                        caseParentValue === question.parentOptionId
                                                    if (isSingleShowCurrentValue) {
                                                        if (question.required) {
                                                            const errors = []
                                                            if (!startYear) {
                                                                errors.push({
                                                                    message: getTitle('6722', 'Year is required'),
                                                                    field: startYearKey,
                                                                })
                                                            }
                                                            if (!startMonth) {
                                                                errors.push({
                                                                    message: getTitle('6721', 'Month is required'),
                                                                    field: startMonthKey,
                                                                })
                                                            }
                                                            if (!startDay) {
                                                                errors.push({
                                                                    message: getTitle('10310', 'Day is required'),
                                                                    field: startDayKey,
                                                                })
                                                            }
                                                            if (!endYear) {
                                                                errors.push({
                                                                    message: getTitle('6722', 'Year is required'),
                                                                    field: endYearKey,
                                                                })
                                                            }
                                                            if (!endMonth) {
                                                                errors.push({
                                                                    message: getTitle('6721', 'Month is required'),
                                                                    field: endMonthKey,
                                                                })
                                                            }
                                                            if (!endDay) {
                                                                errors.push({
                                                                    message: getTitle('10310', 'Day is required'),
                                                                    field: endDayKey,
                                                                })
                                                            }

                                                            if (isEndDateComplete && isStartDateComplete) {
                                                                try {
                                                                    const startDate = dayjs()
                                                                        .year(parseInt(startYear))
                                                                        .month(parseInt(startMonth) - 1)
                                                                        .date(parseInt(startDay))
                                                                        .startOf('day')

                                                                    const endDate = dayjs()
                                                                        .year(parseInt(endYear))
                                                                        .month(parseInt(endMonth) - 1)
                                                                        .date(parseInt(endDay))
                                                                        .startOf('day')

                                                                    if (
                                                                        startDate.isValid() &&
                                                                        endDate.isValid() &&
                                                                        endDate.isBefore(startDate)
                                                                    ) {
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '9453',
                                                                                'End date cannot be earlier than start date'
                                                                            ),
                                                                            field: endDayKey,
                                                                        })
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '9453',
                                                                                'End date cannot be earlier than start date'
                                                                            ),
                                                                            field: endMonthKey,
                                                                        })
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '9453',
                                                                                'End date cannot be earlier than start date'
                                                                            ),
                                                                            field: endYearKey,
                                                                        })
                                                                    }

                                                                    // return true
                                                                } catch (error) {
                                                                    console.error('Date validation error:', error)
                                                                    return true
                                                                }
                                                            }
                                                            if (errors.length > 0) {
                                                                errors.forEach((error) => {
                                                                    if (this.path !== error.field) {
                                                                        this.createError({
                                                                            message: error.message,
                                                                            path: error.field,
                                                                        })
                                                                    }
                                                                })

                                                                const currentFieldError = errors.find(
                                                                    (error) => error.field === this.path
                                                                )
                                                                if (currentFieldError) {
                                                                    console.log('currentFieldError', currentFieldError)
                                                                    return this.createError({
                                                                        message: currentFieldError.message,
                                                                        path: this.path,
                                                                    })
                                                                }
                                                            }
                                                            console.log(errors.length, errors)
                                                            return true
                                                            // return errors.length > 0
                                                        } else {
                                                            const errors = []
                                                            if (isEndDateComplete && isStartDateComplete) {
                                                                try {
                                                                    const startDate = dayjs()
                                                                        .year(parseInt(startYear))
                                                                        .month(parseInt(startMonth) - 1)
                                                                        .date(parseInt(startDay))
                                                                        .startOf('day')

                                                                    const endDate = dayjs()
                                                                        .year(parseInt(endYear))
                                                                        .month(parseInt(endMonth) - 1)
                                                                        .date(parseInt(endDay))
                                                                        .startOf('day')

                                                                    if (
                                                                        startDate.isValid() &&
                                                                        endDate.isValid() &&
                                                                        endDate.isBefore(startDate)
                                                                    ) {
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '9453',
                                                                                'End date cannot be earlier than start date'
                                                                            ),
                                                                            field: endDayKey,
                                                                        })
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '9453',
                                                                                'End date cannot be earlier than start date'
                                                                            ),
                                                                            field: endMonthKey,
                                                                        })
                                                                        errors.push({
                                                                            message: getTitle(
                                                                                '9453',
                                                                                'End date cannot be earlier than start date'
                                                                            ),
                                                                            field: endYearKey,
                                                                        })
                                                                    }

                                                                    // return true
                                                                } catch (error) {
                                                                    console.error('Date validation error:', error)
                                                                    return true
                                                                }
                                                            }
                                                            if (errors.length > 0) {
                                                                errors.forEach((error) => {
                                                                    if (this.path !== error.field) {
                                                                        this.createError({
                                                                            message: error.message,
                                                                            path: error.field,
                                                                        })
                                                                    }
                                                                })

                                                                const currentFieldError = errors.find(
                                                                    (error) => error.field === this.path
                                                                )
                                                                if (currentFieldError) {
                                                                    console.log('currentFieldError', currentFieldError)
                                                                    return this.createError({
                                                                        message: currentFieldError.message,
                                                                        path: this.path,
                                                                    })
                                                                }
                                                            }
                                                            return true
                                                        }
                                                    }
                                                    return true

                                                default:
                                                    return true
                                            }
                                        }
                                    })
                            }

                            acc[startYearKey] = validateBaseSimpleStartRangeDateSchema()
                            acc[startMonthKey] = validateBaseSimpleStartRangeDateSchema()
                            acc[startDayKey] = validateBaseSimpleStartRangeDateSchema()
                            acc[endYearKey] = validateBaseSimpleStartRangeDateSchema()
                            acc[endMonthKey] = validateBaseSimpleStartRangeDateSchema()
                            acc[endDayKey] = validateBaseSimpleStartRangeDateSchema()
                            break
                        case 'number':
                            const validateBaseSimpleNumberSchema = () => {
                                return Yup.number()
                                    .nullable()
                                    .test(testBaseSchemaKey, getTitle('3924', 'Required field'), function (value) {
                                        if (!parent) {
                                            if (question.required) {
                                                return value !== null && value !== undefined
                                            } else {
                                                return true
                                            }
                                        }

                                        const formValues = this.parent
                                        switch (parent.type) {
                                            case 'customField':
                                                switch (parent.customField.typeId) {
                                                    case ApplyV2CustomFieldTypeConst.SingleSelect:
                                                        const [singleParentKey, singleParentValue] =
                                                            Object.entries(formValues).find(([key, value]) => {
                                                                if (key.includes(parent.questionId.toString())) {
                                                                    return true
                                                                }
                                                            }) ?? []

                                                        const isSingleShowCurrentValue =
                                                            singleParentValue === question.parentOptionId
                                                        if (isSingleShowCurrentValue && question.required) {
                                                            return value !== null && value !== undefined
                                                        }
                                                        return true

                                                    case ApplyV2CustomFieldTypeConst.MultiSelect:
                                                        const [multiParentKey, multiParentValue] =
                                                            Object.entries(formValues).find(([key, value]) => {
                                                                if (key.includes(parent.questionId.toString())) {
                                                                    return true
                                                                }
                                                            }) ?? []

                                                        const isMultiShowCurrentValue =
                                                            Array.isArray(multiParentValue) &&
                                                            multiParentValue.includes(question.parentOptionId)

                                                        if (isMultiShowCurrentValue && question.required) {
                                                            return value !== null && value !== undefined
                                                        }
                                                        return true
                                                    default:
                                                        return true
                                                }
                                            case 'multiSelect':
                                                const [multiParentKey, multiParentValue] =
                                                    Object.entries(formValues).find(([key, value]) => {
                                                        if (key.includes(parent.questionId.toString())) {
                                                            return true
                                                        }
                                                    }) ?? []

                                                const isMultiShowCurrentValue =
                                                    Array.isArray(multiParentValue) &&
                                                    multiParentValue.includes(question.parentOptionId)

                                                if (isMultiShowCurrentValue && question.required) {
                                                    return value !== null && value !== undefined
                                                }
                                                return true
                                            case 'singleSelect':
                                            case 'yesNo':
                                            case 'qualifying':
                                                const [caseParentKey, caseParentValue] =
                                                    Object.entries(formValues).find(([key, value]) => {
                                                        if (key.includes(parent.questionId.toString())) {
                                                            return true
                                                        }
                                                    }) ?? []

                                                const isSingleShowCurrentValue =
                                                    caseParentValue === question.parentOptionId
                                                if (isSingleShowCurrentValue && question.required) {
                                                    return value !== null && value !== undefined
                                                }
                                                return true

                                            default:
                                                return true
                                        }
                                    })
                            }
                            acc[questionKey] = validateBaseSimpleNumberSchema()
                            break
                        case 'starRating':
                            const validateBaseSimpleRatingSchema = () => {
                                return Yup.number()
                                    .nullable()
                                    .test(testBaseSchemaKey, getTitle('3924', 'Required field'), function (value) {
                                        if (!parent) {
                                            if (question.required) {
                                                return value !== null && value !== undefined && value > 0
                                            } else {
                                                return true
                                            }
                                        }

                                        const formValues = this.parent
                                        switch (parent.type) {
                                            case 'customField':
                                                switch (parent.customField.typeId) {
                                                    case ApplyV2CustomFieldTypeConst.SingleSelect:
                                                        const [singleParentKey, singleParentValue] =
                                                            Object.entries(formValues).find(([key, value]) => {
                                                                if (key.includes(parent.questionId.toString())) {
                                                                    return true
                                                                }
                                                            }) ?? []

                                                        const isSingleShowCurrentValue =
                                                            singleParentValue === question.parentOptionId
                                                        if (isSingleShowCurrentValue && question.required) {
                                                            return value !== null && value !== undefined && value > 0
                                                        }
                                                        return true

                                                    case ApplyV2CustomFieldTypeConst.MultiSelect:
                                                        const [multiParentKey, multiParentValue] =
                                                            Object.entries(formValues).find(([key, value]) => {
                                                                if (key.includes(parent.questionId.toString())) {
                                                                    return true
                                                                }
                                                            }) ?? []

                                                        const isMultiShowCurrentValue =
                                                            Array.isArray(multiParentValue) &&
                                                            multiParentValue.includes(question.parentOptionId)

                                                        if (isMultiShowCurrentValue && question.required) {
                                                            return value !== null && value !== undefined && value > 0
                                                        }
                                                        return true
                                                    default:
                                                        return true
                                                }
                                            case 'multiSelect':
                                                const [multiParentKey, multiParentValue] =
                                                    Object.entries(formValues).find(([key, value]) => {
                                                        if (key.includes(parent.questionId.toString())) {
                                                            return true
                                                        }
                                                    }) ?? []

                                                const isMultiShowCurrentValue =
                                                    Array.isArray(multiParentValue) &&
                                                    multiParentValue.includes(question.parentOptionId)

                                                if (isMultiShowCurrentValue && question.required) {
                                                    return value !== null && value !== undefined && value > 0
                                                }
                                                return true
                                            case 'singleSelect':
                                            case 'yesNo':
                                            case 'qualifying':
                                                const [caseParentKey, caseParentValue] =
                                                    Object.entries(formValues).find(([key, value]) => {
                                                        if (key.includes(parent.questionId.toString())) {
                                                            return true
                                                        }
                                                    }) ?? []

                                                const isSingleShowCurrentValue =
                                                    caseParentValue === question.parentOptionId
                                                if (isSingleShowCurrentValue && question.required) {
                                                    return value !== null && value !== undefined && value > 0
                                                }
                                                return true

                                            default:
                                                return true
                                        }
                                    })
                            }
                            acc[questionKey] = validateBaseSimpleRatingSchema()
                            break
                        case 'attachment':
                            acc[questionKey] = Yup.array()
                                .of(
                                    Yup.object().shape({
                                        name: Yup.string().max(128).required('File name is required'),
                                        ext: Yup.string().required('File extension is required'),
                                        // base64: Yup.string().required('File content is required'),
                                        size: Yup.number().required('File size is required'),
                                    })
                                )
                                .test('required', getTitle('3924', 'Required filed'), function (value) {
                                    if (!parent) {
                                        if (question.required) {
                                            return !!value && value.length > 0
                                        }
                                        return true
                                    }

                                    const formValues = this.parent
                                    switch (parent.type) {
                                        case 'customField':
                                            switch (parent.customField.typeId) {
                                                case ApplyV2CustomFieldTypeConst.SingleSelect:
                                                    const [singleParentKey, singleParentValue] =
                                                        Object.entries(formValues).find(([key, value]) => {
                                                            if (key.includes(parent.questionId.toString())) {
                                                                return true
                                                            }
                                                        }) ?? []

                                                    const isSingleShowCurrentValue =
                                                        singleParentValue === question.parentOptionId
                                                    if (isSingleShowCurrentValue && question.required) {
                                                        return (
                                                            value !== null &&
                                                            value !== undefined &&
                                                            Array.isArray(value) &&
                                                            value.length > 0
                                                        )
                                                    }
                                                    return true

                                                case ApplyV2CustomFieldTypeConst.MultiSelect:
                                                    const [multiParentKey, multiParentValue] =
                                                        Object.entries(formValues).find(([key, value]) => {
                                                            if (key.includes(parent.questionId.toString())) {
                                                                return true
                                                            }
                                                        }) ?? []

                                                    const isMultiShowCurrentValue =
                                                        Array.isArray(multiParentValue) &&
                                                        multiParentValue.includes(question.parentOptionId)

                                                    if (isMultiShowCurrentValue && question.required) {
                                                        return (
                                                            value !== null &&
                                                            value !== undefined &&
                                                            Array.isArray(value) &&
                                                            value.length > 0
                                                        )
                                                    }
                                                    return true
                                                default:
                                                    return true
                                            }
                                        case 'multiSelect':
                                            const [multiParentKey, multiParentValue] =
                                                Object.entries(formValues).find(([key, value]) => {
                                                    if (key.includes(parent.questionId.toString())) {
                                                        return true
                                                    }
                                                }) ?? []

                                            const isMultiShowCurrentValue =
                                                Array.isArray(multiParentValue) &&
                                                multiParentValue.includes(question.parentOptionId)

                                            if (isMultiShowCurrentValue && question.required) {
                                                return (
                                                    value !== null &&
                                                    value !== undefined &&
                                                    Array.isArray(value) &&
                                                    value.length > 0
                                                )
                                            }
                                            return true
                                        case 'singleSelect':
                                        case 'yesNo':
                                        case 'qualifying':
                                            const [caseParentKey, caseParentValue] =
                                                Object.entries(formValues).find(([key, value]) => {
                                                    if (key.includes(parent.questionId.toString())) {
                                                        return true
                                                    }
                                                }) ?? []

                                            const isSingleShowCurrentValue = caseParentValue === question.parentOptionId
                                            if (isSingleShowCurrentValue && question.required) {
                                                return (
                                                    value !== null &&
                                                    value !== undefined &&
                                                    Array.isArray(value) &&
                                                    value.length > 0
                                                )
                                            }
                                            return true

                                        default:
                                            return true
                                    }
                                })
                            break
                        case 'yesNo':
                        case 'qualifying':
                            const validateBaseSimpleYesNoSchema = () => {
                                return Yup.number()
                                    .nullable()
                                    .test(testBaseSchemaKey, getTitle('3924', 'Required field'), function (value) {
                                        if (!parent) {
                                            if (question.required) {
                                                return value !== null && value !== undefined
                                            } else {
                                                return true
                                            }
                                        }

                                        const formValues = this.parent
                                        switch (parent.type) {
                                            case 'customField':
                                                switch (parent.customField.typeId) {
                                                    case ApplyV2CustomFieldTypeConst.SingleSelect:
                                                        const [singleParentKey, singleParentValue] =
                                                            Object.entries(formValues).find(([key, value]) => {
                                                                if (key.includes(parent.questionId.toString())) {
                                                                    return true
                                                                }
                                                            }) ?? []

                                                        const isSingleShowCurrentValue =
                                                            singleParentValue === question.parentOptionId
                                                        if (isSingleShowCurrentValue && question.required) {
                                                            return value !== null && value !== undefined
                                                        }
                                                        return true

                                                    case ApplyV2CustomFieldTypeConst.MultiSelect:
                                                        const [multiParentKey, multiParentValue] =
                                                            Object.entries(formValues).find(([key, value]) => {
                                                                if (key.includes(parent.questionId.toString())) {
                                                                    return true
                                                                }
                                                            }) ?? []

                                                        const isMultiShowCurrentValue =
                                                            Array.isArray(multiParentValue) &&
                                                            multiParentValue.includes(question.parentOptionId)

                                                        if (isMultiShowCurrentValue && question.required) {
                                                            return value !== null && value !== undefined
                                                        }
                                                        return true
                                                    default:
                                                        return true
                                                }
                                            case 'multiSelect':
                                                const [multiParentKey, multiParentValue] =
                                                    Object.entries(formValues).find(([key, value]) => {
                                                        if (key.includes(parent.questionId.toString())) {
                                                            return true
                                                        }
                                                    }) ?? []

                                                const isMultiShowCurrentValue =
                                                    Array.isArray(multiParentValue) &&
                                                    multiParentValue.includes(question.parentOptionId)

                                                if (isMultiShowCurrentValue && question.required) {
                                                    return value !== null && value !== undefined
                                                }
                                                return true
                                            case 'singleSelect':
                                            case 'yesNo':
                                            case 'qualifying':
                                                const [caseParentKey, caseParentValue] =
                                                    Object.entries(formValues).find(([key, value]) => {
                                                        if (key.includes(parent.questionId.toString())) {
                                                            return true
                                                        }
                                                    }) ?? []

                                                const isSingleShowCurrentValue =
                                                    caseParentValue === question.parentOptionId
                                                if (isSingleShowCurrentValue && question.required) {
                                                    return value !== null && value !== undefined
                                                }
                                                return true

                                            default:
                                                return true
                                        }
                                    })
                            }
                            acc[questionKey] = validateBaseSimpleYesNoSchema()
                            break
                        // case 'qualifying':
                        //     acc[questionKey as QualifyingKey] = Yup.number().nullable()
                        //     if (question.required) {
                        //         acc[questionKey as QualifyingKey] = acc[questionKey as QualifyingKey].required(
                        //             getTitle('3924', 'Required filed')
                        //         )
                        //     }
                        //     break
                        case 'text':
                            let baseTextSchema = Yup.string().max(1024, 'Maximum length 1024 characters').nullable()
                            const validateBaseTextSchemaParentValueRequired = () => {
                                return baseTextSchema.test(
                                    testBaseSchemaKey,
                                    getTitle('3924', 'Required field'),
                                    function (value) {
                                        if (!parent) {
                                            if (question.required) {
                                                return value !== null && value !== undefined && value !== ''
                                            } else {
                                                return true
                                            }
                                        }

                                        const formValues = this.parent

                                        switch (parent.type) {
                                            case 'customField':
                                                switch (parent.customField.typeId) {
                                                    case ApplyV2CustomFieldTypeConst.SingleSelect:
                                                        const [singleParentKey, singleParentValue] =
                                                            Object.entries(formValues).find(([key, value]) => {
                                                                if (key.includes(parent.questionId.toString())) {
                                                                    return true
                                                                }
                                                            }) ?? []

                                                        const isSingleShowCurrentValue =
                                                            singleParentValue === question.parentOptionId
                                                        if (isSingleShowCurrentValue && question.required) {
                                                            return value !== null && value !== undefined && value !== ''
                                                        }
                                                        return true

                                                    case ApplyV2CustomFieldTypeConst.MultiSelect:
                                                        const [multiParentKey, multiParentValue] =
                                                            Object.entries(formValues).find(([key, value]) => {
                                                                if (key.includes(parent.questionId.toString())) {
                                                                    return true
                                                                }
                                                            }) ?? []

                                                        const isMultiShowCurrentValue =
                                                            Array.isArray(multiParentValue) &&
                                                            multiParentValue.includes(question.parentOptionId)

                                                        if (isMultiShowCurrentValue && question.required) {
                                                            return value !== null && value !== undefined && value !== ''
                                                        }
                                                        return true
                                                    default:
                                                        return true
                                                }
                                            case 'multiSelect':
                                                const [multiParentKey, multiParentValue] =
                                                    Object.entries(formValues).find(([key, value]) => {
                                                        if (key.includes(parent.questionId.toString())) {
                                                            return true
                                                        }
                                                    }) ?? []

                                                const isMultiShowCurrentValue =
                                                    Array.isArray(multiParentValue) &&
                                                    multiParentValue.includes(question.parentOptionId)

                                                if (isMultiShowCurrentValue && question.required) {
                                                    return value !== null && value !== undefined && value !== ''
                                                }
                                                return true
                                            case 'singleSelect':
                                            case 'yesNo':
                                            case 'qualifying':
                                                const [caseParentKey, caseParentValue] =
                                                    Object.entries(formValues).find(([key, value]) => {
                                                        if (key.includes(parent.questionId.toString())) {
                                                            return true
                                                        }
                                                    }) ?? []

                                                const isSingleShowCurrentValue =
                                                    caseParentValue === question.parentOptionId
                                                if (isSingleShowCurrentValue && question.required) {
                                                    return value !== null && value !== undefined && value !== ''
                                                }
                                                return true

                                            default:
                                                return true
                                        }

                                        // TODO -  TRUE - passed validation, FALSE - has error 'Required field'
                                        // return false
                                        return true
                                    }
                                )
                            }
                            acc[questionKey] = validateBaseTextSchemaParentValueRequired()

                            break
                        case 'longText':
                            // acc[questionKey] = Yup.string().max(5000, 'Maximum length 5000 characters').nullable()
                            // if (question.required) {
                            //     acc[questionKey] = acc[questionKey].required(getTitle('3924', 'Required filed'))
                            // }
                            let baseLongTextSchema = Yup.string().max(5000, 'Maximum length 5000 characters').nullable()
                            const validateLongTextParentValueRequired = () => {
                                return baseLongTextSchema.test(
                                    testBaseSchemaKey,
                                    getTitle('3924', 'Required field'),
                                    function (value) {
                                        if (!parent) {
                                            if (question.required) {
                                                return value !== null && value !== undefined && value !== ''
                                            } else {
                                                return true
                                            }
                                        }

                                        const formValues = this.parent

                                        switch (parent.type) {
                                            case 'customField':
                                                switch (parent.customField.typeId) {
                                                    case ApplyV2CustomFieldTypeConst.SingleSelect:
                                                        const [singleParentKey, singleParentValue] =
                                                            Object.entries(formValues).find(([key, value]) => {
                                                                if (key.includes(parent.questionId.toString())) {
                                                                    return true
                                                                }
                                                            }) ?? []

                                                        const isSingleShowCurrentValue =
                                                            singleParentValue === question.parentOptionId
                                                        if (isSingleShowCurrentValue && question.required) {
                                                            return value !== null && value !== undefined && value !== ''
                                                        }
                                                        return true

                                                    case ApplyV2CustomFieldTypeConst.MultiSelect:
                                                        const [multiParentKey, multiParentValue] =
                                                            Object.entries(formValues).find(([key, value]) => {
                                                                if (key.includes(parent.questionId.toString())) {
                                                                    return true
                                                                }
                                                            }) ?? []

                                                        const isMultiShowCurrentValue =
                                                            Array.isArray(multiParentValue) &&
                                                            multiParentValue.includes(question.parentOptionId)

                                                        if (isMultiShowCurrentValue && question.required) {
                                                            return value !== null && value !== undefined && value !== ''
                                                        }
                                                        return true
                                                    default:
                                                        return true
                                                }
                                            case 'multiSelect':
                                                const [multiParentKey, multiParentValue] =
                                                    Object.entries(formValues).find(([key, value]) => {
                                                        if (key.includes(parent.questionId.toString())) {
                                                            return true
                                                        }
                                                    }) ?? []

                                                const isMultiShowCurrentValue =
                                                    Array.isArray(multiParentValue) &&
                                                    multiParentValue.includes(question.parentOptionId)

                                                if (isMultiShowCurrentValue && question.required) {
                                                    return value !== null && value !== undefined && value !== ''
                                                }
                                                return true
                                            case 'singleSelect':
                                            case 'yesNo':
                                            case 'qualifying':
                                                const [caseParentKey, caseParentValue] =
                                                    Object.entries(formValues).find(([key, value]) => {
                                                        if (key.includes(parent.questionId.toString())) {
                                                            return true
                                                        }
                                                    }) ?? []

                                                const isSingleShowCurrentValue =
                                                    caseParentValue === question.parentOptionId
                                                if (isSingleShowCurrentValue && question.required) {
                                                    return value !== null && value !== undefined && value !== ''
                                                }
                                                return true

                                            default:
                                                return true
                                        }

                                        // TODO -  TRUE - passed validation, FALSE - has error 'Required field'
                                    }
                                )
                            }
                            acc[questionKey] = validateLongTextParentValueRequired()
                            break
                        default:
                            acc[questionKey] = Yup.mixed()
                    }
                }

                if (question.children?.length) {
                    const childSchema = buildValidationSchema(question.children, question)
                    Object.assign(acc, childSchema.fields)
                }

                return acc
            },
            {} as Record<string, any>
            // {} as Partial<ApplyV2QuestionsFormValues>
        )

        return Yup.object().shape(shape)
    }

    const validationSchema = buildValidationSchema(questions)

    const formik = useFormik<ApplyV2QuestionsFormValues>({
        initialValues: buildInitialValues(questions),
        validationSchema: validationSchema,
        onSubmit: async (values, { setErrors }) => {
            // console.log(formik.errors)
            validateRequest({
                uid: storageData?.postInitUid || '',
            })
                .unwrap()
                .then((res) => {
                    console.log(res)
                    if (res.data?.isValid) {
                        onNextStep()
                    } else {
                        const newErrors: Record<string, string> = {}
                        const missingQuestionIds = res.data?.missingQuestionIds ?? []

                        missingQuestionIds.forEach((questionId: number) => {
                            Object.keys(formik.values).forEach((key) => {
                                if (key.endsWith(`_${questionId}`)) {
                                    newErrors[key] = getTitle('3924', 'Required field')
                                }
                            })
                        })

                        formik.setErrors({
                            ...formik.errors,
                            ...newErrors,
                        })

                        const touchedFields: FormikTouched<ApplyV2QuestionsFormValues> = { ...formik.touched }

                        Object.keys(newErrors).forEach((key) => {
                            const fieldKey = key as keyof ApplyV2QuestionsFormValues

                            if (key.startsWith('attachment_')) {
                                touchedFields[fieldKey as AttachmentKey] = [true] as any
                            } else {
                                touchedFields[fieldKey] = true as any
                            }
                        })

                        formik.setTouched(touchedFields, false)
                    }
                })
        },
        enableReinitialize: true,
    })

    // console.log(questions)
    // console.log(formik.isSubmitting, isValidateLoading)

    return (
        <FormikProvider value={formik}>
            <form className={`${baseClass}__container`} onSubmit={formik.handleSubmit}>
                <ApplyV2QuestionsList
                    questions={questions}
                    setIsErrorUpdateAnswer={setIsErrorUpdateAnswer}
                    refetchAllQuestions={refetchAllQuestions}
                    parent={{
                        parentValue: null,
                        parentType: null,
                        parentQuestionId: null,
                        parentOptionId: null,
                        customFieldType: null,
                    }}
                    addLoadingItem={addLoadingItem}
                    removeLoadingItem={removeLoadingItem}
                />
                <div className={`ApplyDialogV2__next ${baseClass}__next`}>
                    {!settingsData?.steps?.question?.required && (
                        <ApplyV2Button
                            variant={'transparent'}
                            className={`ApplyDialogV2__next--btn ApplyDialogV2__next--btn-skip`}
                            rightIcon={'>'}
                            isDisabled={isValidateLoading || formik.isSubmitting}
                            onClick={() => {
                                onNextStep()
                            }}
                        >
                            {getTitle('6107', 'Skip')}
                        </ApplyV2Button>
                    )}
                    <ApplyV2Button
                        type="submit"
                        variant={'primary'}
                        className={`ApplyDialogV2__next--btn ApplyDialogV2__next--btn-submit ${baseClass}__next--btn`}
                        // isLoading={isValidateLoading || formik.isSubmitting || loadingItems.size > 0}
                        isLoading={isValidateLoading}
                        // isDisabled={
                        //     isValidateLoading || !formik.isValid || formik.isSubmitting || loadingItems.size > 0
                        // }
                        // onClick={() => {
                        //     console.log(formik.values, formik.errors)
                        // }}
                    >
                        {getTitle('3035', 'Next')}
                    </ApplyV2Button>
                </div>
            </form>
        </FormikProvider>
    )
}

export default ApplyV2QuestionsStep
